/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CustomerCUsersIndexRouteImport } from './routes/_customer/c/users/index'
import { Route as CustomerCTagsIndexRouteImport } from './routes/_customer/c/tags/index'
import { Route as CustomerCSubnetsIndexRouteImport } from './routes/_customer/c/subnets/index'
import { Route as CustomerCProfileIndexRouteImport } from './routes/_customer/c/profile/index'
import { Route as CustomerCLogsIndexRouteImport } from './routes/_customer/c/logs/index'
import { Route as CustomerCGroupsIndexRouteImport } from './routes/_customer/c/groups/index'
import { Route as CustomerCExitnodesIndexRouteImport } from './routes/_customer/c/exitnodes/index'
import { Route as CustomerCDevicesIndexRouteImport } from './routes/_customer/c/devices/index'
import { Route as CustomerCDashboardIndexRouteImport } from './routes/_customer/c/dashboard/index'
import { Route as AdminAUsersIndexRouteImport } from './routes/_admin/a/users/index'
import { Route as AdminATagsIndexRouteImport } from './routes/_admin/a/tags/index'
import { Route as AdminASubnetsIndexRouteImport } from './routes/_admin/a/subnets/index'
import { Route as AdminASettingsIndexRouteImport } from './routes/_admin/a/settings/index'
import { Route as AdminAProfileIndexRouteImport } from './routes/_admin/a/profile/index'
import { Route as AdminAPreauthkeysIndexRouteImport } from './routes/_admin/a/preauthkeys/index'
import { Route as AdminALogsIndexRouteImport } from './routes/_admin/a/logs/index'
import { Route as AdminAGroupsIndexRouteImport } from './routes/_admin/a/groups/index'
import { Route as AdminAExitnodesIndexRouteImport } from './routes/_admin/a/exitnodes/index'
import { Route as AdminADnsIndexRouteImport } from './routes/_admin/a/dns/index'
import { Route as AdminADevicesIndexRouteImport } from './routes/_admin/a/devices/index'
import { Route as AdminADashboardIndexRouteImport } from './routes/_admin/a/dashboard/index'
import { Route as AdminAAccountsIndexRouteImport } from './routes/_admin/a/accounts/index'
import { Route as StaticSTailscaleLoginSuccessRouteImport } from './routes/_static/s/tailscale-login/success'
import { Route as StaticSTailscaleLoginServerErrorRouteImport } from './routes/_static/s/tailscale-login/server-error'
import { Route as StaticSTailscaleLoginOutdatedRouteImport } from './routes/_static/s/tailscale-login/outdated'
import { Route as StaticSTailscaleLoginInvalidCsrfRouteImport } from './routes/_static/s/tailscale-login/invalid-csrf'
import { Route as StaticSTailscaleLoginDisabledRouteImport } from './routes/_static/s/tailscale-login/disabled'
import { Route as CustomerCSubnetsSubnetsRouteImport } from './routes/_customer/c/subnets/_subnets'
import { Route as CustomerCGroupsGroupsRouteImport } from './routes/_customer/c/groups/_groups'
import { Route as CustomerCExitnodesExitnodesRouteImport } from './routes/_customer/c/exitnodes/_exitnodes'
import { Route as AdminASubnetsSubnetsRouteImport } from './routes/_admin/a/subnets/_subnets'
import { Route as AdminASettingsSettingsRouteImport } from './routes/_admin/a/settings/_settings'
import { Route as AdminAGroupsGroupsRouteImport } from './routes/_admin/a/groups/_groups'
import { Route as AdminAExitnodesExitnodesRouteImport } from './routes/_admin/a/exitnodes/_exitnodes'
import { Route as AdminADnsDnsRouteImport } from './routes/_admin/a/dns/_dns'
import { Route as AdminADevicesCreateServerRouteImport } from './routes/_admin/a/devices/create-server'
import { Route as StaticSTailscaleLoginTokenIndexRouteImport } from './routes/_static/s/tailscale-login/$token/index'
import { Route as StaticSTailscaleLoginTokenExternalTailscaleLoginRouteImport } from './routes/_static/s/tailscale-login/$token/external-tailscale-login'
import { Route as CustomerCUsersUserIdUserRouteImport } from './routes/_customer/c/users/$userId/_user'
import { Route as CustomerCTagsTagIdTagsRouteImport } from './routes/_customer/c/tags/$tagId/_tags'
import { Route as CustomerCSubnetsSubnetsPendingRouteImport } from './routes/_customer/c/subnets/_subnets/pending'
import { Route as CustomerCSubnetsSubnetsApprovedRouteImport } from './routes/_customer/c/subnets/_subnets/approved'
import { Route as CustomerCSubnetsSubnetIdSubnetRouteImport } from './routes/_customer/c/subnets/$subnetId/_subnet'
import { Route as CustomerCGroupsGroupsScimRouteImport } from './routes/_customer/c/groups/_groups/scim'
import { Route as CustomerCGroupsGroupsLocalRouteImport } from './routes/_customer/c/groups/_groups/local'
import { Route as CustomerCGroupsGroupsLdapRouteImport } from './routes/_customer/c/groups/_groups/ldap'
import { Route as CustomerCGroupsGroupIdGroupRouteImport } from './routes/_customer/c/groups/$groupId/_group'
import { Route as CustomerCExitnodesExitnodesPendingRouteImport } from './routes/_customer/c/exitnodes/_exitnodes/pending'
import { Route as CustomerCExitnodesExitnodesApprovedRouteImport } from './routes/_customer/c/exitnodes/_exitnodes/approved'
import { Route as CustomerCDevicesDeviceIdDeviceRouteImport } from './routes/_customer/c/devices/$deviceId/_device'
import { Route as AdminAUsersUserIdUserRouteImport } from './routes/_admin/a/users/$userId/_user'
import { Route as AdminATagsTagIdTagsRouteImport } from './routes/_admin/a/tags/$tagId/_tags'
import { Route as AdminASubnetsSubnetsPendingRouteImport } from './routes/_admin/a/subnets/_subnets/pending'
import { Route as AdminASubnetsSubnetsApprovedRouteImport } from './routes/_admin/a/subnets/_subnets/approved'
import { Route as AdminASubnetsSubnetIdSubnetRouteImport } from './routes/_admin/a/subnets/$subnetId/_subnet'
import { Route as AdminASettingsSettingsScimRouteImport } from './routes/_admin/a/settings/_settings/scim'
import { Route as AdminASettingsSettingsLdapRouteImport } from './routes/_admin/a/settings/_settings/ldap'
import { Route as AdminASettingsSettingsGeneralRouteImport } from './routes/_admin/a/settings/_settings/general'
import { Route as AdminAGroupsGroupsScimRouteImport } from './routes/_admin/a/groups/_groups/scim'
import { Route as AdminAGroupsGroupsLocalRouteImport } from './routes/_admin/a/groups/_groups/local'
import { Route as AdminAGroupsGroupsLdapRouteImport } from './routes/_admin/a/groups/_groups/ldap'
import { Route as AdminAGroupsGroupIdGroupRouteImport } from './routes/_admin/a/groups/$groupId/_group'
import { Route as AdminAExitnodesExitnodesPendingRouteImport } from './routes/_admin/a/exitnodes/_exitnodes/pending'
import { Route as AdminAExitnodesExitnodesApprovedRouteImport } from './routes/_admin/a/exitnodes/_exitnodes/approved'
import { Route as AdminADnsDnsSplitRouteImport } from './routes/_admin/a/dns/_dns/split'
import { Route as AdminADnsDnsSearchDomainsRouteImport } from './routes/_admin/a/dns/_dns/search-domains'
import { Route as AdminADnsDnsGlobalRouteImport } from './routes/_admin/a/dns/_dns/global'
import { Route as AdminADnsDnsExtraRecordsRouteImport } from './routes/_admin/a/dns/_dns/extra-records'
import { Route as AdminADevicesDeviceIdDeviceRouteImport } from './routes/_admin/a/devices/$deviceId/_device'
import { Route as AdminASettingsSettingsOidcIndexRouteImport } from './routes/_admin/a/settings/_settings/oidc/index'
import { Route as CustomerCUsersUserIdUserGeneralRouteImport } from './routes/_customer/c/users/$userId/_user/general'
import { Route as CustomerCTagsTagIdTagsOutboundAclsRouteImport } from './routes/_customer/c/tags/$tagId/_tags/outbound-acls'
import { Route as CustomerCTagsTagIdTagsInboundAclsRouteImport } from './routes/_customer/c/tags/$tagId/_tags/inbound-acls'
import { Route as CustomerCTagsTagIdTagsAssociatedRouteImport } from './routes/_customer/c/tags/$tagId/_tags/associated'
import { Route as CustomerCSubnetsSubnetIdSubnetOutboundAclsRouteImport } from './routes/_customer/c/subnets/$subnetId/_subnet/outbound-acls'
import { Route as CustomerCSubnetsSubnetIdSubnetInboundAclsRouteImport } from './routes/_customer/c/subnets/$subnetId/_subnet/inbound-acls'
import { Route as CustomerCGroupsGroupIdGroupOutboundAclsRouteImport } from './routes/_customer/c/groups/$groupId/_group/outbound-acls'
import { Route as CustomerCGroupsGroupIdGroupInboundAclsRouteImport } from './routes/_customer/c/groups/$groupId/_group/inbound-acls'
import { Route as CustomerCGroupsGroupIdGroupGeneralRouteImport } from './routes/_customer/c/groups/$groupId/_group/general'
import { Route as CustomerCDevicesDeviceIdDeviceOutboundAclsRouteImport } from './routes/_customer/c/devices/$deviceId/_device/outbound-acls'
import { Route as CustomerCDevicesDeviceIdDeviceInboundAclsRouteImport } from './routes/_customer/c/devices/$deviceId/_device/inbound-acls'
import { Route as CustomerCDevicesDeviceIdDeviceGeneralRouteImport } from './routes/_customer/c/devices/$deviceId/_device/general'
import { Route as AdminAUsersUserIdUserGeneralRouteImport } from './routes/_admin/a/users/$userId/_user/general'
import { Route as AdminATagsTagIdTagsOutboundAclsRouteImport } from './routes/_admin/a/tags/$tagId/_tags/outbound-acls'
import { Route as AdminATagsTagIdTagsInboundAclsRouteImport } from './routes/_admin/a/tags/$tagId/_tags/inbound-acls'
import { Route as AdminATagsTagIdTagsAssociatedRouteImport } from './routes/_admin/a/tags/$tagId/_tags/associated'
import { Route as AdminASubnetsSubnetIdSubnetOutboundAclsRouteImport } from './routes/_admin/a/subnets/$subnetId/_subnet/outbound-acls'
import { Route as AdminASubnetsSubnetIdSubnetInboundAclsRouteImport } from './routes/_admin/a/subnets/$subnetId/_subnet/inbound-acls'
import { Route as AdminASettingsSettingsOidcTrufflepigRouteImport } from './routes/_admin/a/settings/_settings/oidc/trufflepig'
import { Route as AdminAGroupsGroupIdGroupOutboundAclsRouteImport } from './routes/_admin/a/groups/$groupId/_group/outbound-acls'
import { Route as AdminAGroupsGroupIdGroupInboundAclsRouteImport } from './routes/_admin/a/groups/$groupId/_group/inbound-acls'
import { Route as AdminAGroupsGroupIdGroupGeneralRouteImport } from './routes/_admin/a/groups/$groupId/_group/general'
import { Route as AdminADevicesDeviceIdDeviceOutboundAclsRouteImport } from './routes/_admin/a/devices/$deviceId/_device/outbound-acls'
import { Route as AdminADevicesDeviceIdDeviceInboundAclsRouteImport } from './routes/_admin/a/devices/$deviceId/_device/inbound-acls'
import { Route as AdminADevicesDeviceIdDeviceGeneralRouteImport } from './routes/_admin/a/devices/$deviceId/_device/general'
import { Route as AdminASettingsSettingsOidcCustomerVpnRouteImport } from './routes/_admin/a/settings/_settings/oidc/customer/vpn'
import { Route as AdminASettingsSettingsOidcCustomerAdminRouteImport } from './routes/_admin/a/settings/_settings/oidc/customer/admin'

const StaticLazyRouteImport = createFileRoute('/_static')()
const CustomerLazyRouteImport = createFileRoute('/_customer')()
const AdminLazyRouteImport = createFileRoute('/_admin')()
const CustomerCSubnetsRouteImport = createFileRoute('/_customer/c/subnets')()
const CustomerCGroupsRouteImport = createFileRoute('/_customer/c/groups')()
const CustomerCExitnodesRouteImport = createFileRoute(
  '/_customer/c/exitnodes',
)()
const AdminASubnetsRouteImport = createFileRoute('/_admin/a/subnets')()
const AdminASettingsRouteImport = createFileRoute('/_admin/a/settings')()
const AdminAGroupsRouteImport = createFileRoute('/_admin/a/groups')()
const AdminAExitnodesRouteImport = createFileRoute('/_admin/a/exitnodes')()
const AdminADnsRouteImport = createFileRoute('/_admin/a/dns')()
const CustomerCUsersUserIdRouteImport = createFileRoute(
  '/_customer/c/users/$userId',
)()
const CustomerCTagsTagIdRouteImport = createFileRoute(
  '/_customer/c/tags/$tagId',
)()
const CustomerCSubnetsSubnetIdRouteImport = createFileRoute(
  '/_customer/c/subnets/$subnetId',
)()
const CustomerCGroupsGroupIdRouteImport = createFileRoute(
  '/_customer/c/groups/$groupId',
)()
const CustomerCDevicesDeviceIdRouteImport = createFileRoute(
  '/_customer/c/devices/$deviceId',
)()
const AdminAUsersUserIdRouteImport = createFileRoute(
  '/_admin/a/users/$userId',
)()
const AdminATagsTagIdRouteImport = createFileRoute('/_admin/a/tags/$tagId')()
const AdminASubnetsSubnetIdRouteImport = createFileRoute(
  '/_admin/a/subnets/$subnetId',
)()
const AdminAGroupsGroupIdRouteImport = createFileRoute(
  '/_admin/a/groups/$groupId',
)()
const AdminADevicesDeviceIdRouteImport = createFileRoute(
  '/_admin/a/devices/$deviceId',
)()

const StaticLazyRoute = StaticLazyRouteImport.update({
  id: '/_static',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_static.lazy').then((d) => d.Route))
const CustomerLazyRoute = CustomerLazyRouteImport.update({
  id: '/_customer',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_customer.lazy').then((d) => d.Route))
const AdminLazyRoute = AdminLazyRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_admin.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerCSubnetsRoute = CustomerCSubnetsRouteImport.update({
  id: '/c/subnets',
  path: '/c/subnets',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const CustomerCGroupsRoute = CustomerCGroupsRouteImport.update({
  id: '/c/groups',
  path: '/c/groups',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const CustomerCExitnodesRoute = CustomerCExitnodesRouteImport.update({
  id: '/c/exitnodes',
  path: '/c/exitnodes',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const AdminASubnetsRoute = AdminASubnetsRouteImport.update({
  id: '/a/subnets',
  path: '/a/subnets',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminASettingsRoute = AdminASettingsRouteImport.update({
  id: '/a/settings',
  path: '/a/settings',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAGroupsRoute = AdminAGroupsRouteImport.update({
  id: '/a/groups',
  path: '/a/groups',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAExitnodesRoute = AdminAExitnodesRouteImport.update({
  id: '/a/exitnodes',
  path: '/a/exitnodes',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminADnsRoute = AdminADnsRouteImport.update({
  id: '/a/dns',
  path: '/a/dns',
  getParentRoute: () => AdminLazyRoute,
} as any)
const CustomerCUsersUserIdRoute = CustomerCUsersUserIdRouteImport.update({
  id: '/c/users/$userId',
  path: '/c/users/$userId',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const CustomerCTagsTagIdRoute = CustomerCTagsTagIdRouteImport.update({
  id: '/c/tags/$tagId',
  path: '/c/tags/$tagId',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const CustomerCSubnetsSubnetIdRoute =
  CustomerCSubnetsSubnetIdRouteImport.update({
    id: '/$subnetId',
    path: '/$subnetId',
    getParentRoute: () => CustomerCSubnetsRoute,
  } as any)
const CustomerCGroupsGroupIdRoute = CustomerCGroupsGroupIdRouteImport.update({
  id: '/$groupId',
  path: '/$groupId',
  getParentRoute: () => CustomerCGroupsRoute,
} as any)
const CustomerCDevicesDeviceIdRoute =
  CustomerCDevicesDeviceIdRouteImport.update({
    id: '/c/devices/$deviceId',
    path: '/c/devices/$deviceId',
    getParentRoute: () => CustomerLazyRoute,
  } as any)
const AdminAUsersUserIdRoute = AdminAUsersUserIdRouteImport.update({
  id: '/a/users/$userId',
  path: '/a/users/$userId',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminATagsTagIdRoute = AdminATagsTagIdRouteImport.update({
  id: '/a/tags/$tagId',
  path: '/a/tags/$tagId',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminASubnetsSubnetIdRoute = AdminASubnetsSubnetIdRouteImport.update({
  id: '/$subnetId',
  path: '/$subnetId',
  getParentRoute: () => AdminASubnetsRoute,
} as any)
const AdminAGroupsGroupIdRoute = AdminAGroupsGroupIdRouteImport.update({
  id: '/$groupId',
  path: '/$groupId',
  getParentRoute: () => AdminAGroupsRoute,
} as any)
const AdminADevicesDeviceIdRoute = AdminADevicesDeviceIdRouteImport.update({
  id: '/a/devices/$deviceId',
  path: '/a/devices/$deviceId',
  getParentRoute: () => AdminLazyRoute,
} as any)
const CustomerCUsersIndexRoute = CustomerCUsersIndexRouteImport.update({
  id: '/c/users/',
  path: '/c/users/',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const CustomerCTagsIndexRoute = CustomerCTagsIndexRouteImport.update({
  id: '/c/tags/',
  path: '/c/tags/',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const CustomerCSubnetsIndexRoute = CustomerCSubnetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CustomerCSubnetsRoute,
} as any)
const CustomerCProfileIndexRoute = CustomerCProfileIndexRouteImport.update({
  id: '/c/profile/',
  path: '/c/profile/',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const CustomerCLogsIndexRoute = CustomerCLogsIndexRouteImport.update({
  id: '/c/logs/',
  path: '/c/logs/',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const CustomerCGroupsIndexRoute = CustomerCGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CustomerCGroupsRoute,
} as any)
const CustomerCExitnodesIndexRoute = CustomerCExitnodesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CustomerCExitnodesRoute,
} as any)
const CustomerCDevicesIndexRoute = CustomerCDevicesIndexRouteImport.update({
  id: '/c/devices/',
  path: '/c/devices/',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const CustomerCDashboardIndexRoute = CustomerCDashboardIndexRouteImport.update({
  id: '/c/dashboard/',
  path: '/c/dashboard/',
  getParentRoute: () => CustomerLazyRoute,
} as any)
const AdminAUsersIndexRoute = AdminAUsersIndexRouteImport.update({
  id: '/a/users/',
  path: '/a/users/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminATagsIndexRoute = AdminATagsIndexRouteImport.update({
  id: '/a/tags/',
  path: '/a/tags/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminASubnetsIndexRoute = AdminASubnetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminASubnetsRoute,
} as any)
const AdminASettingsIndexRoute = AdminASettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminASettingsRoute,
} as any)
const AdminAProfileIndexRoute = AdminAProfileIndexRouteImport.update({
  id: '/a/profile/',
  path: '/a/profile/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAPreauthkeysIndexRoute = AdminAPreauthkeysIndexRouteImport.update({
  id: '/a/preauthkeys/',
  path: '/a/preauthkeys/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminALogsIndexRoute = AdminALogsIndexRouteImport.update({
  id: '/a/logs/',
  path: '/a/logs/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAGroupsIndexRoute = AdminAGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAGroupsRoute,
} as any)
const AdminAExitnodesIndexRoute = AdminAExitnodesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAExitnodesRoute,
} as any)
const AdminADnsIndexRoute = AdminADnsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminADnsRoute,
} as any)
const AdminADevicesIndexRoute = AdminADevicesIndexRouteImport.update({
  id: '/a/devices/',
  path: '/a/devices/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminADashboardIndexRoute = AdminADashboardIndexRouteImport.update({
  id: '/a/dashboard/',
  path: '/a/dashboard/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAAccountsIndexRoute = AdminAAccountsIndexRouteImport.update({
  id: '/a/accounts/',
  path: '/a/accounts/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const StaticSTailscaleLoginSuccessRoute =
  StaticSTailscaleLoginSuccessRouteImport.update({
    id: '/s/tailscale-login/success',
    path: '/s/tailscale-login/success',
    getParentRoute: () => StaticLazyRoute,
  } as any)
const StaticSTailscaleLoginServerErrorRoute =
  StaticSTailscaleLoginServerErrorRouteImport.update({
    id: '/s/tailscale-login/server-error',
    path: '/s/tailscale-login/server-error',
    getParentRoute: () => StaticLazyRoute,
  } as any)
const StaticSTailscaleLoginOutdatedRoute =
  StaticSTailscaleLoginOutdatedRouteImport.update({
    id: '/s/tailscale-login/outdated',
    path: '/s/tailscale-login/outdated',
    getParentRoute: () => StaticLazyRoute,
  } as any)
const StaticSTailscaleLoginInvalidCsrfRoute =
  StaticSTailscaleLoginInvalidCsrfRouteImport.update({
    id: '/s/tailscale-login/invalid-csrf',
    path: '/s/tailscale-login/invalid-csrf',
    getParentRoute: () => StaticLazyRoute,
  } as any)
const StaticSTailscaleLoginDisabledRoute =
  StaticSTailscaleLoginDisabledRouteImport.update({
    id: '/s/tailscale-login/disabled',
    path: '/s/tailscale-login/disabled',
    getParentRoute: () => StaticLazyRoute,
  } as any)
const CustomerCSubnetsSubnetsRoute = CustomerCSubnetsSubnetsRouteImport.update({
  id: '/_subnets',
  getParentRoute: () => CustomerCSubnetsRoute,
} as any)
const CustomerCGroupsGroupsRoute = CustomerCGroupsGroupsRouteImport.update({
  id: '/_groups',
  getParentRoute: () => CustomerCGroupsRoute,
} as any)
const CustomerCExitnodesExitnodesRoute =
  CustomerCExitnodesExitnodesRouteImport.update({
    id: '/_exitnodes',
    getParentRoute: () => CustomerCExitnodesRoute,
  } as any)
const AdminASubnetsSubnetsRoute = AdminASubnetsSubnetsRouteImport.update({
  id: '/_subnets',
  getParentRoute: () => AdminASubnetsRoute,
} as any)
const AdminASettingsSettingsRoute = AdminASettingsSettingsRouteImport.update({
  id: '/_settings',
  getParentRoute: () => AdminASettingsRoute,
} as any)
const AdminAGroupsGroupsRoute = AdminAGroupsGroupsRouteImport.update({
  id: '/_groups',
  getParentRoute: () => AdminAGroupsRoute,
} as any)
const AdminAExitnodesExitnodesRoute =
  AdminAExitnodesExitnodesRouteImport.update({
    id: '/_exitnodes',
    getParentRoute: () => AdminAExitnodesRoute,
  } as any)
const AdminADnsDnsRoute = AdminADnsDnsRouteImport.update({
  id: '/_dns',
  getParentRoute: () => AdminADnsRoute,
} as any)
const AdminADevicesCreateServerRoute =
  AdminADevicesCreateServerRouteImport.update({
    id: '/a/devices/create-server',
    path: '/a/devices/create-server',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const StaticSTailscaleLoginTokenIndexRoute =
  StaticSTailscaleLoginTokenIndexRouteImport.update({
    id: '/s/tailscale-login/$token/',
    path: '/s/tailscale-login/$token/',
    getParentRoute: () => StaticLazyRoute,
  } as any)
const StaticSTailscaleLoginTokenExternalTailscaleLoginRoute =
  StaticSTailscaleLoginTokenExternalTailscaleLoginRouteImport.update({
    id: '/s/tailscale-login/$token/external-tailscale-login',
    path: '/s/tailscale-login/$token/external-tailscale-login',
    getParentRoute: () => StaticLazyRoute,
  } as any)
const CustomerCUsersUserIdUserRoute =
  CustomerCUsersUserIdUserRouteImport.update({
    id: '/_user',
    getParentRoute: () => CustomerCUsersUserIdRoute,
  } as any)
const CustomerCTagsTagIdTagsRoute = CustomerCTagsTagIdTagsRouteImport.update({
  id: '/_tags',
  getParentRoute: () => CustomerCTagsTagIdRoute,
} as any)
const CustomerCSubnetsSubnetsPendingRoute =
  CustomerCSubnetsSubnetsPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => CustomerCSubnetsSubnetsRoute,
  } as any)
const CustomerCSubnetsSubnetsApprovedRoute =
  CustomerCSubnetsSubnetsApprovedRouteImport.update({
    id: '/approved',
    path: '/approved',
    getParentRoute: () => CustomerCSubnetsSubnetsRoute,
  } as any)
const CustomerCSubnetsSubnetIdSubnetRoute =
  CustomerCSubnetsSubnetIdSubnetRouteImport.update({
    id: '/_subnet',
    getParentRoute: () => CustomerCSubnetsSubnetIdRoute,
  } as any)
const CustomerCGroupsGroupsScimRoute =
  CustomerCGroupsGroupsScimRouteImport.update({
    id: '/scim',
    path: '/scim',
    getParentRoute: () => CustomerCGroupsGroupsRoute,
  } as any)
const CustomerCGroupsGroupsLocalRoute =
  CustomerCGroupsGroupsLocalRouteImport.update({
    id: '/local',
    path: '/local',
    getParentRoute: () => CustomerCGroupsGroupsRoute,
  } as any)
const CustomerCGroupsGroupsLdapRoute =
  CustomerCGroupsGroupsLdapRouteImport.update({
    id: '/ldap',
    path: '/ldap',
    getParentRoute: () => CustomerCGroupsGroupsRoute,
  } as any)
const CustomerCGroupsGroupIdGroupRoute =
  CustomerCGroupsGroupIdGroupRouteImport.update({
    id: '/_group',
    getParentRoute: () => CustomerCGroupsGroupIdRoute,
  } as any)
const CustomerCExitnodesExitnodesPendingRoute =
  CustomerCExitnodesExitnodesPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => CustomerCExitnodesExitnodesRoute,
  } as any)
const CustomerCExitnodesExitnodesApprovedRoute =
  CustomerCExitnodesExitnodesApprovedRouteImport.update({
    id: '/approved',
    path: '/approved',
    getParentRoute: () => CustomerCExitnodesExitnodesRoute,
  } as any)
const CustomerCDevicesDeviceIdDeviceRoute =
  CustomerCDevicesDeviceIdDeviceRouteImport.update({
    id: '/_device',
    getParentRoute: () => CustomerCDevicesDeviceIdRoute,
  } as any)
const AdminAUsersUserIdUserRoute = AdminAUsersUserIdUserRouteImport.update({
  id: '/_user',
  getParentRoute: () => AdminAUsersUserIdRoute,
} as any)
const AdminATagsTagIdTagsRoute = AdminATagsTagIdTagsRouteImport.update({
  id: '/_tags',
  getParentRoute: () => AdminATagsTagIdRoute,
} as any)
const AdminASubnetsSubnetsPendingRoute =
  AdminASubnetsSubnetsPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => AdminASubnetsSubnetsRoute,
  } as any)
const AdminASubnetsSubnetsApprovedRoute =
  AdminASubnetsSubnetsApprovedRouteImport.update({
    id: '/approved',
    path: '/approved',
    getParentRoute: () => AdminASubnetsSubnetsRoute,
  } as any)
const AdminASubnetsSubnetIdSubnetRoute =
  AdminASubnetsSubnetIdSubnetRouteImport.update({
    id: '/_subnet',
    getParentRoute: () => AdminASubnetsSubnetIdRoute,
  } as any)
const AdminASettingsSettingsScimRoute =
  AdminASettingsSettingsScimRouteImport.update({
    id: '/scim',
    path: '/scim',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)
const AdminASettingsSettingsLdapRoute =
  AdminASettingsSettingsLdapRouteImport.update({
    id: '/ldap',
    path: '/ldap',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)
const AdminASettingsSettingsGeneralRoute =
  AdminASettingsSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)
const AdminAGroupsGroupsScimRoute = AdminAGroupsGroupsScimRouteImport.update({
  id: '/scim',
  path: '/scim',
  getParentRoute: () => AdminAGroupsGroupsRoute,
} as any)
const AdminAGroupsGroupsLocalRoute = AdminAGroupsGroupsLocalRouteImport.update({
  id: '/local',
  path: '/local',
  getParentRoute: () => AdminAGroupsGroupsRoute,
} as any)
const AdminAGroupsGroupsLdapRoute = AdminAGroupsGroupsLdapRouteImport.update({
  id: '/ldap',
  path: '/ldap',
  getParentRoute: () => AdminAGroupsGroupsRoute,
} as any)
const AdminAGroupsGroupIdGroupRoute =
  AdminAGroupsGroupIdGroupRouteImport.update({
    id: '/_group',
    getParentRoute: () => AdminAGroupsGroupIdRoute,
  } as any)
const AdminAExitnodesExitnodesPendingRoute =
  AdminAExitnodesExitnodesPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => AdminAExitnodesExitnodesRoute,
  } as any)
const AdminAExitnodesExitnodesApprovedRoute =
  AdminAExitnodesExitnodesApprovedRouteImport.update({
    id: '/approved',
    path: '/approved',
    getParentRoute: () => AdminAExitnodesExitnodesRoute,
  } as any)
const AdminADnsDnsSplitRoute = AdminADnsDnsSplitRouteImport.update({
  id: '/split',
  path: '/split',
  getParentRoute: () => AdminADnsDnsRoute,
} as any)
const AdminADnsDnsSearchDomainsRoute =
  AdminADnsDnsSearchDomainsRouteImport.update({
    id: '/search-domains',
    path: '/search-domains',
    getParentRoute: () => AdminADnsDnsRoute,
  } as any)
const AdminADnsDnsGlobalRoute = AdminADnsDnsGlobalRouteImport.update({
  id: '/global',
  path: '/global',
  getParentRoute: () => AdminADnsDnsRoute,
} as any)
const AdminADnsDnsExtraRecordsRoute =
  AdminADnsDnsExtraRecordsRouteImport.update({
    id: '/extra-records',
    path: '/extra-records',
    getParentRoute: () => AdminADnsDnsRoute,
  } as any)
const AdminADevicesDeviceIdDeviceRoute =
  AdminADevicesDeviceIdDeviceRouteImport.update({
    id: '/_device',
    getParentRoute: () => AdminADevicesDeviceIdRoute,
  } as any)
const AdminASettingsSettingsOidcIndexRoute =
  AdminASettingsSettingsOidcIndexRouteImport.update({
    id: '/oidc/',
    path: '/oidc/',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)
const CustomerCUsersUserIdUserGeneralRoute =
  CustomerCUsersUserIdUserGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => CustomerCUsersUserIdUserRoute,
  } as any)
const CustomerCTagsTagIdTagsOutboundAclsRoute =
  CustomerCTagsTagIdTagsOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => CustomerCTagsTagIdTagsRoute,
  } as any)
const CustomerCTagsTagIdTagsInboundAclsRoute =
  CustomerCTagsTagIdTagsInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => CustomerCTagsTagIdTagsRoute,
  } as any)
const CustomerCTagsTagIdTagsAssociatedRoute =
  CustomerCTagsTagIdTagsAssociatedRouteImport.update({
    id: '/associated',
    path: '/associated',
    getParentRoute: () => CustomerCTagsTagIdTagsRoute,
  } as any)
const CustomerCSubnetsSubnetIdSubnetOutboundAclsRoute =
  CustomerCSubnetsSubnetIdSubnetOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => CustomerCSubnetsSubnetIdSubnetRoute,
  } as any)
const CustomerCSubnetsSubnetIdSubnetInboundAclsRoute =
  CustomerCSubnetsSubnetIdSubnetInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => CustomerCSubnetsSubnetIdSubnetRoute,
  } as any)
const CustomerCGroupsGroupIdGroupOutboundAclsRoute =
  CustomerCGroupsGroupIdGroupOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => CustomerCGroupsGroupIdGroupRoute,
  } as any)
const CustomerCGroupsGroupIdGroupInboundAclsRoute =
  CustomerCGroupsGroupIdGroupInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => CustomerCGroupsGroupIdGroupRoute,
  } as any)
const CustomerCGroupsGroupIdGroupGeneralRoute =
  CustomerCGroupsGroupIdGroupGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => CustomerCGroupsGroupIdGroupRoute,
  } as any)
const CustomerCDevicesDeviceIdDeviceOutboundAclsRoute =
  CustomerCDevicesDeviceIdDeviceOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => CustomerCDevicesDeviceIdDeviceRoute,
  } as any)
const CustomerCDevicesDeviceIdDeviceInboundAclsRoute =
  CustomerCDevicesDeviceIdDeviceInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => CustomerCDevicesDeviceIdDeviceRoute,
  } as any)
const CustomerCDevicesDeviceIdDeviceGeneralRoute =
  CustomerCDevicesDeviceIdDeviceGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => CustomerCDevicesDeviceIdDeviceRoute,
  } as any)
const AdminAUsersUserIdUserGeneralRoute =
  AdminAUsersUserIdUserGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AdminAUsersUserIdUserRoute,
  } as any)
const AdminATagsTagIdTagsOutboundAclsRoute =
  AdminATagsTagIdTagsOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => AdminATagsTagIdTagsRoute,
  } as any)
const AdminATagsTagIdTagsInboundAclsRoute =
  AdminATagsTagIdTagsInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => AdminATagsTagIdTagsRoute,
  } as any)
const AdminATagsTagIdTagsAssociatedRoute =
  AdminATagsTagIdTagsAssociatedRouteImport.update({
    id: '/associated',
    path: '/associated',
    getParentRoute: () => AdminATagsTagIdTagsRoute,
  } as any)
const AdminASubnetsSubnetIdSubnetOutboundAclsRoute =
  AdminASubnetsSubnetIdSubnetOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => AdminASubnetsSubnetIdSubnetRoute,
  } as any)
const AdminASubnetsSubnetIdSubnetInboundAclsRoute =
  AdminASubnetsSubnetIdSubnetInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => AdminASubnetsSubnetIdSubnetRoute,
  } as any)
const AdminASettingsSettingsOidcTrufflepigRoute =
  AdminASettingsSettingsOidcTrufflepigRouteImport.update({
    id: '/oidc/trufflepig',
    path: '/oidc/trufflepig',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)
const AdminAGroupsGroupIdGroupOutboundAclsRoute =
  AdminAGroupsGroupIdGroupOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => AdminAGroupsGroupIdGroupRoute,
  } as any)
const AdminAGroupsGroupIdGroupInboundAclsRoute =
  AdminAGroupsGroupIdGroupInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => AdminAGroupsGroupIdGroupRoute,
  } as any)
const AdminAGroupsGroupIdGroupGeneralRoute =
  AdminAGroupsGroupIdGroupGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AdminAGroupsGroupIdGroupRoute,
  } as any)
const AdminADevicesDeviceIdDeviceOutboundAclsRoute =
  AdminADevicesDeviceIdDeviceOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => AdminADevicesDeviceIdDeviceRoute,
  } as any)
const AdminADevicesDeviceIdDeviceInboundAclsRoute =
  AdminADevicesDeviceIdDeviceInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => AdminADevicesDeviceIdDeviceRoute,
  } as any)
const AdminADevicesDeviceIdDeviceGeneralRoute =
  AdminADevicesDeviceIdDeviceGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AdminADevicesDeviceIdDeviceRoute,
  } as any)
const AdminASettingsSettingsOidcCustomerVpnRoute =
  AdminASettingsSettingsOidcCustomerVpnRouteImport.update({
    id: '/oidc/customer/vpn',
    path: '/oidc/customer/vpn',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)
const AdminASettingsSettingsOidcCustomerAdminRoute =
  AdminASettingsSettingsOidcCustomerAdminRouteImport.update({
    id: '/oidc/customer/admin',
    path: '/oidc/customer/admin',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/a/devices/create-server': typeof AdminADevicesCreateServerRoute
  '/a/dns': typeof AdminADnsDnsRouteWithChildren
  '/a/exitnodes': typeof AdminAExitnodesExitnodesRouteWithChildren
  '/a/groups': typeof AdminAGroupsGroupsRouteWithChildren
  '/a/settings': typeof AdminASettingsSettingsRouteWithChildren
  '/a/subnets': typeof AdminASubnetsSubnetsRouteWithChildren
  '/c/exitnodes': typeof CustomerCExitnodesExitnodesRouteWithChildren
  '/c/groups': typeof CustomerCGroupsGroupsRouteWithChildren
  '/c/subnets': typeof CustomerCSubnetsSubnetsRouteWithChildren
  '/s/tailscale-login/disabled': typeof StaticSTailscaleLoginDisabledRoute
  '/s/tailscale-login/invalid-csrf': typeof StaticSTailscaleLoginInvalidCsrfRoute
  '/s/tailscale-login/outdated': typeof StaticSTailscaleLoginOutdatedRoute
  '/s/tailscale-login/server-error': typeof StaticSTailscaleLoginServerErrorRoute
  '/s/tailscale-login/success': typeof StaticSTailscaleLoginSuccessRoute
  '/a/accounts': typeof AdminAAccountsIndexRoute
  '/a/dashboard': typeof AdminADashboardIndexRoute
  '/a/devices': typeof AdminADevicesIndexRoute
  '/a/dns/': typeof AdminADnsIndexRoute
  '/a/exitnodes/': typeof AdminAExitnodesIndexRoute
  '/a/groups/': typeof AdminAGroupsIndexRoute
  '/a/logs': typeof AdminALogsIndexRoute
  '/a/preauthkeys': typeof AdminAPreauthkeysIndexRoute
  '/a/profile': typeof AdminAProfileIndexRoute
  '/a/settings/': typeof AdminASettingsIndexRoute
  '/a/subnets/': typeof AdminASubnetsIndexRoute
  '/a/tags': typeof AdminATagsIndexRoute
  '/a/users': typeof AdminAUsersIndexRoute
  '/c/dashboard': typeof CustomerCDashboardIndexRoute
  '/c/devices': typeof CustomerCDevicesIndexRoute
  '/c/exitnodes/': typeof CustomerCExitnodesIndexRoute
  '/c/groups/': typeof CustomerCGroupsIndexRoute
  '/c/logs': typeof CustomerCLogsIndexRoute
  '/c/profile': typeof CustomerCProfileIndexRoute
  '/c/subnets/': typeof CustomerCSubnetsIndexRoute
  '/c/tags': typeof CustomerCTagsIndexRoute
  '/c/users': typeof CustomerCUsersIndexRoute
  '/a/devices/$deviceId': typeof AdminADevicesDeviceIdDeviceRouteWithChildren
  '/a/dns/extra-records': typeof AdminADnsDnsExtraRecordsRoute
  '/a/dns/global': typeof AdminADnsDnsGlobalRoute
  '/a/dns/search-domains': typeof AdminADnsDnsSearchDomainsRoute
  '/a/dns/split': typeof AdminADnsDnsSplitRoute
  '/a/exitnodes/approved': typeof AdminAExitnodesExitnodesApprovedRoute
  '/a/exitnodes/pending': typeof AdminAExitnodesExitnodesPendingRoute
  '/a/groups/$groupId': typeof AdminAGroupsGroupIdGroupRouteWithChildren
  '/a/groups/ldap': typeof AdminAGroupsGroupsLdapRoute
  '/a/groups/local': typeof AdminAGroupsGroupsLocalRoute
  '/a/groups/scim': typeof AdminAGroupsGroupsScimRoute
  '/a/settings/general': typeof AdminASettingsSettingsGeneralRoute
  '/a/settings/ldap': typeof AdminASettingsSettingsLdapRoute
  '/a/settings/scim': typeof AdminASettingsSettingsScimRoute
  '/a/subnets/$subnetId': typeof AdminASubnetsSubnetIdSubnetRouteWithChildren
  '/a/subnets/approved': typeof AdminASubnetsSubnetsApprovedRoute
  '/a/subnets/pending': typeof AdminASubnetsSubnetsPendingRoute
  '/a/tags/$tagId': typeof AdminATagsTagIdTagsRouteWithChildren
  '/a/users/$userId': typeof AdminAUsersUserIdUserRouteWithChildren
  '/c/devices/$deviceId': typeof CustomerCDevicesDeviceIdDeviceRouteWithChildren
  '/c/exitnodes/approved': typeof CustomerCExitnodesExitnodesApprovedRoute
  '/c/exitnodes/pending': typeof CustomerCExitnodesExitnodesPendingRoute
  '/c/groups/$groupId': typeof CustomerCGroupsGroupIdGroupRouteWithChildren
  '/c/groups/ldap': typeof CustomerCGroupsGroupsLdapRoute
  '/c/groups/local': typeof CustomerCGroupsGroupsLocalRoute
  '/c/groups/scim': typeof CustomerCGroupsGroupsScimRoute
  '/c/subnets/$subnetId': typeof CustomerCSubnetsSubnetIdSubnetRouteWithChildren
  '/c/subnets/approved': typeof CustomerCSubnetsSubnetsApprovedRoute
  '/c/subnets/pending': typeof CustomerCSubnetsSubnetsPendingRoute
  '/c/tags/$tagId': typeof CustomerCTagsTagIdTagsRouteWithChildren
  '/c/users/$userId': typeof CustomerCUsersUserIdUserRouteWithChildren
  '/s/tailscale-login/$token/external-tailscale-login': typeof StaticSTailscaleLoginTokenExternalTailscaleLoginRoute
  '/s/tailscale-login/$token': typeof StaticSTailscaleLoginTokenIndexRoute
  '/a/devices/$deviceId/general': typeof AdminADevicesDeviceIdDeviceGeneralRoute
  '/a/devices/$deviceId/inbound-acls': typeof AdminADevicesDeviceIdDeviceInboundAclsRoute
  '/a/devices/$deviceId/outbound-acls': typeof AdminADevicesDeviceIdDeviceOutboundAclsRoute
  '/a/groups/$groupId/general': typeof AdminAGroupsGroupIdGroupGeneralRoute
  '/a/groups/$groupId/inbound-acls': typeof AdminAGroupsGroupIdGroupInboundAclsRoute
  '/a/groups/$groupId/outbound-acls': typeof AdminAGroupsGroupIdGroupOutboundAclsRoute
  '/a/settings/oidc/trufflepig': typeof AdminASettingsSettingsOidcTrufflepigRoute
  '/a/subnets/$subnetId/inbound-acls': typeof AdminASubnetsSubnetIdSubnetInboundAclsRoute
  '/a/subnets/$subnetId/outbound-acls': typeof AdminASubnetsSubnetIdSubnetOutboundAclsRoute
  '/a/tags/$tagId/associated': typeof AdminATagsTagIdTagsAssociatedRoute
  '/a/tags/$tagId/inbound-acls': typeof AdminATagsTagIdTagsInboundAclsRoute
  '/a/tags/$tagId/outbound-acls': typeof AdminATagsTagIdTagsOutboundAclsRoute
  '/a/users/$userId/general': typeof AdminAUsersUserIdUserGeneralRoute
  '/c/devices/$deviceId/general': typeof CustomerCDevicesDeviceIdDeviceGeneralRoute
  '/c/devices/$deviceId/inbound-acls': typeof CustomerCDevicesDeviceIdDeviceInboundAclsRoute
  '/c/devices/$deviceId/outbound-acls': typeof CustomerCDevicesDeviceIdDeviceOutboundAclsRoute
  '/c/groups/$groupId/general': typeof CustomerCGroupsGroupIdGroupGeneralRoute
  '/c/groups/$groupId/inbound-acls': typeof CustomerCGroupsGroupIdGroupInboundAclsRoute
  '/c/groups/$groupId/outbound-acls': typeof CustomerCGroupsGroupIdGroupOutboundAclsRoute
  '/c/subnets/$subnetId/inbound-acls': typeof CustomerCSubnetsSubnetIdSubnetInboundAclsRoute
  '/c/subnets/$subnetId/outbound-acls': typeof CustomerCSubnetsSubnetIdSubnetOutboundAclsRoute
  '/c/tags/$tagId/associated': typeof CustomerCTagsTagIdTagsAssociatedRoute
  '/c/tags/$tagId/inbound-acls': typeof CustomerCTagsTagIdTagsInboundAclsRoute
  '/c/tags/$tagId/outbound-acls': typeof CustomerCTagsTagIdTagsOutboundAclsRoute
  '/c/users/$userId/general': typeof CustomerCUsersUserIdUserGeneralRoute
  '/a/settings/oidc': typeof AdminASettingsSettingsOidcIndexRoute
  '/a/settings/oidc/customer/admin': typeof AdminASettingsSettingsOidcCustomerAdminRoute
  '/a/settings/oidc/customer/vpn': typeof AdminASettingsSettingsOidcCustomerVpnRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/a/devices/create-server': typeof AdminADevicesCreateServerRoute
  '/a/dns': typeof AdminADnsIndexRoute
  '/a/exitnodes': typeof AdminAExitnodesIndexRoute
  '/a/groups': typeof AdminAGroupsIndexRoute
  '/a/settings': typeof AdminASettingsIndexRoute
  '/a/subnets': typeof AdminASubnetsIndexRoute
  '/c/exitnodes': typeof CustomerCExitnodesIndexRoute
  '/c/groups': typeof CustomerCGroupsIndexRoute
  '/c/subnets': typeof CustomerCSubnetsIndexRoute
  '/s/tailscale-login/disabled': typeof StaticSTailscaleLoginDisabledRoute
  '/s/tailscale-login/invalid-csrf': typeof StaticSTailscaleLoginInvalidCsrfRoute
  '/s/tailscale-login/outdated': typeof StaticSTailscaleLoginOutdatedRoute
  '/s/tailscale-login/server-error': typeof StaticSTailscaleLoginServerErrorRoute
  '/s/tailscale-login/success': typeof StaticSTailscaleLoginSuccessRoute
  '/a/accounts': typeof AdminAAccountsIndexRoute
  '/a/dashboard': typeof AdminADashboardIndexRoute
  '/a/devices': typeof AdminADevicesIndexRoute
  '/a/logs': typeof AdminALogsIndexRoute
  '/a/preauthkeys': typeof AdminAPreauthkeysIndexRoute
  '/a/profile': typeof AdminAProfileIndexRoute
  '/a/tags': typeof AdminATagsIndexRoute
  '/a/users': typeof AdminAUsersIndexRoute
  '/c/dashboard': typeof CustomerCDashboardIndexRoute
  '/c/devices': typeof CustomerCDevicesIndexRoute
  '/c/logs': typeof CustomerCLogsIndexRoute
  '/c/profile': typeof CustomerCProfileIndexRoute
  '/c/tags': typeof CustomerCTagsIndexRoute
  '/c/users': typeof CustomerCUsersIndexRoute
  '/a/devices/$deviceId': typeof AdminADevicesDeviceIdDeviceRouteWithChildren
  '/a/dns/extra-records': typeof AdminADnsDnsExtraRecordsRoute
  '/a/dns/global': typeof AdminADnsDnsGlobalRoute
  '/a/dns/search-domains': typeof AdminADnsDnsSearchDomainsRoute
  '/a/dns/split': typeof AdminADnsDnsSplitRoute
  '/a/exitnodes/approved': typeof AdminAExitnodesExitnodesApprovedRoute
  '/a/exitnodes/pending': typeof AdminAExitnodesExitnodesPendingRoute
  '/a/groups/$groupId': typeof AdminAGroupsGroupIdGroupRouteWithChildren
  '/a/groups/ldap': typeof AdminAGroupsGroupsLdapRoute
  '/a/groups/local': typeof AdminAGroupsGroupsLocalRoute
  '/a/groups/scim': typeof AdminAGroupsGroupsScimRoute
  '/a/settings/general': typeof AdminASettingsSettingsGeneralRoute
  '/a/settings/ldap': typeof AdminASettingsSettingsLdapRoute
  '/a/settings/scim': typeof AdminASettingsSettingsScimRoute
  '/a/subnets/$subnetId': typeof AdminASubnetsSubnetIdSubnetRouteWithChildren
  '/a/subnets/approved': typeof AdminASubnetsSubnetsApprovedRoute
  '/a/subnets/pending': typeof AdminASubnetsSubnetsPendingRoute
  '/a/tags/$tagId': typeof AdminATagsTagIdTagsRouteWithChildren
  '/a/users/$userId': typeof AdminAUsersUserIdUserRouteWithChildren
  '/c/devices/$deviceId': typeof CustomerCDevicesDeviceIdDeviceRouteWithChildren
  '/c/exitnodes/approved': typeof CustomerCExitnodesExitnodesApprovedRoute
  '/c/exitnodes/pending': typeof CustomerCExitnodesExitnodesPendingRoute
  '/c/groups/$groupId': typeof CustomerCGroupsGroupIdGroupRouteWithChildren
  '/c/groups/ldap': typeof CustomerCGroupsGroupsLdapRoute
  '/c/groups/local': typeof CustomerCGroupsGroupsLocalRoute
  '/c/groups/scim': typeof CustomerCGroupsGroupsScimRoute
  '/c/subnets/$subnetId': typeof CustomerCSubnetsSubnetIdSubnetRouteWithChildren
  '/c/subnets/approved': typeof CustomerCSubnetsSubnetsApprovedRoute
  '/c/subnets/pending': typeof CustomerCSubnetsSubnetsPendingRoute
  '/c/tags/$tagId': typeof CustomerCTagsTagIdTagsRouteWithChildren
  '/c/users/$userId': typeof CustomerCUsersUserIdUserRouteWithChildren
  '/s/tailscale-login/$token/external-tailscale-login': typeof StaticSTailscaleLoginTokenExternalTailscaleLoginRoute
  '/s/tailscale-login/$token': typeof StaticSTailscaleLoginTokenIndexRoute
  '/a/devices/$deviceId/general': typeof AdminADevicesDeviceIdDeviceGeneralRoute
  '/a/devices/$deviceId/inbound-acls': typeof AdminADevicesDeviceIdDeviceInboundAclsRoute
  '/a/devices/$deviceId/outbound-acls': typeof AdminADevicesDeviceIdDeviceOutboundAclsRoute
  '/a/groups/$groupId/general': typeof AdminAGroupsGroupIdGroupGeneralRoute
  '/a/groups/$groupId/inbound-acls': typeof AdminAGroupsGroupIdGroupInboundAclsRoute
  '/a/groups/$groupId/outbound-acls': typeof AdminAGroupsGroupIdGroupOutboundAclsRoute
  '/a/settings/oidc/trufflepig': typeof AdminASettingsSettingsOidcTrufflepigRoute
  '/a/subnets/$subnetId/inbound-acls': typeof AdminASubnetsSubnetIdSubnetInboundAclsRoute
  '/a/subnets/$subnetId/outbound-acls': typeof AdminASubnetsSubnetIdSubnetOutboundAclsRoute
  '/a/tags/$tagId/associated': typeof AdminATagsTagIdTagsAssociatedRoute
  '/a/tags/$tagId/inbound-acls': typeof AdminATagsTagIdTagsInboundAclsRoute
  '/a/tags/$tagId/outbound-acls': typeof AdminATagsTagIdTagsOutboundAclsRoute
  '/a/users/$userId/general': typeof AdminAUsersUserIdUserGeneralRoute
  '/c/devices/$deviceId/general': typeof CustomerCDevicesDeviceIdDeviceGeneralRoute
  '/c/devices/$deviceId/inbound-acls': typeof CustomerCDevicesDeviceIdDeviceInboundAclsRoute
  '/c/devices/$deviceId/outbound-acls': typeof CustomerCDevicesDeviceIdDeviceOutboundAclsRoute
  '/c/groups/$groupId/general': typeof CustomerCGroupsGroupIdGroupGeneralRoute
  '/c/groups/$groupId/inbound-acls': typeof CustomerCGroupsGroupIdGroupInboundAclsRoute
  '/c/groups/$groupId/outbound-acls': typeof CustomerCGroupsGroupIdGroupOutboundAclsRoute
  '/c/subnets/$subnetId/inbound-acls': typeof CustomerCSubnetsSubnetIdSubnetInboundAclsRoute
  '/c/subnets/$subnetId/outbound-acls': typeof CustomerCSubnetsSubnetIdSubnetOutboundAclsRoute
  '/c/tags/$tagId/associated': typeof CustomerCTagsTagIdTagsAssociatedRoute
  '/c/tags/$tagId/inbound-acls': typeof CustomerCTagsTagIdTagsInboundAclsRoute
  '/c/tags/$tagId/outbound-acls': typeof CustomerCTagsTagIdTagsOutboundAclsRoute
  '/c/users/$userId/general': typeof CustomerCUsersUserIdUserGeneralRoute
  '/a/settings/oidc': typeof AdminASettingsSettingsOidcIndexRoute
  '/a/settings/oidc/customer/admin': typeof AdminASettingsSettingsOidcCustomerAdminRoute
  '/a/settings/oidc/customer/vpn': typeof AdminASettingsSettingsOidcCustomerVpnRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminLazyRouteWithChildren
  '/_customer': typeof CustomerLazyRouteWithChildren
  '/_static': typeof StaticLazyRouteWithChildren
  '/_admin/a/devices/create-server': typeof AdminADevicesCreateServerRoute
  '/_admin/a/dns': typeof AdminADnsRouteWithChildren
  '/_admin/a/dns/_dns': typeof AdminADnsDnsRouteWithChildren
  '/_admin/a/exitnodes': typeof AdminAExitnodesRouteWithChildren
  '/_admin/a/exitnodes/_exitnodes': typeof AdminAExitnodesExitnodesRouteWithChildren
  '/_admin/a/groups': typeof AdminAGroupsRouteWithChildren
  '/_admin/a/groups/_groups': typeof AdminAGroupsGroupsRouteWithChildren
  '/_admin/a/settings': typeof AdminASettingsRouteWithChildren
  '/_admin/a/settings/_settings': typeof AdminASettingsSettingsRouteWithChildren
  '/_admin/a/subnets': typeof AdminASubnetsRouteWithChildren
  '/_admin/a/subnets/_subnets': typeof AdminASubnetsSubnetsRouteWithChildren
  '/_customer/c/exitnodes': typeof CustomerCExitnodesRouteWithChildren
  '/_customer/c/exitnodes/_exitnodes': typeof CustomerCExitnodesExitnodesRouteWithChildren
  '/_customer/c/groups': typeof CustomerCGroupsRouteWithChildren
  '/_customer/c/groups/_groups': typeof CustomerCGroupsGroupsRouteWithChildren
  '/_customer/c/subnets': typeof CustomerCSubnetsRouteWithChildren
  '/_customer/c/subnets/_subnets': typeof CustomerCSubnetsSubnetsRouteWithChildren
  '/_static/s/tailscale-login/disabled': typeof StaticSTailscaleLoginDisabledRoute
  '/_static/s/tailscale-login/invalid-csrf': typeof StaticSTailscaleLoginInvalidCsrfRoute
  '/_static/s/tailscale-login/outdated': typeof StaticSTailscaleLoginOutdatedRoute
  '/_static/s/tailscale-login/server-error': typeof StaticSTailscaleLoginServerErrorRoute
  '/_static/s/tailscale-login/success': typeof StaticSTailscaleLoginSuccessRoute
  '/_admin/a/accounts/': typeof AdminAAccountsIndexRoute
  '/_admin/a/dashboard/': typeof AdminADashboardIndexRoute
  '/_admin/a/devices/': typeof AdminADevicesIndexRoute
  '/_admin/a/dns/': typeof AdminADnsIndexRoute
  '/_admin/a/exitnodes/': typeof AdminAExitnodesIndexRoute
  '/_admin/a/groups/': typeof AdminAGroupsIndexRoute
  '/_admin/a/logs/': typeof AdminALogsIndexRoute
  '/_admin/a/preauthkeys/': typeof AdminAPreauthkeysIndexRoute
  '/_admin/a/profile/': typeof AdminAProfileIndexRoute
  '/_admin/a/settings/': typeof AdminASettingsIndexRoute
  '/_admin/a/subnets/': typeof AdminASubnetsIndexRoute
  '/_admin/a/tags/': typeof AdminATagsIndexRoute
  '/_admin/a/users/': typeof AdminAUsersIndexRoute
  '/_customer/c/dashboard/': typeof CustomerCDashboardIndexRoute
  '/_customer/c/devices/': typeof CustomerCDevicesIndexRoute
  '/_customer/c/exitnodes/': typeof CustomerCExitnodesIndexRoute
  '/_customer/c/groups/': typeof CustomerCGroupsIndexRoute
  '/_customer/c/logs/': typeof CustomerCLogsIndexRoute
  '/_customer/c/profile/': typeof CustomerCProfileIndexRoute
  '/_customer/c/subnets/': typeof CustomerCSubnetsIndexRoute
  '/_customer/c/tags/': typeof CustomerCTagsIndexRoute
  '/_customer/c/users/': typeof CustomerCUsersIndexRoute
  '/_admin/a/devices/$deviceId': typeof AdminADevicesDeviceIdRouteWithChildren
  '/_admin/a/devices/$deviceId/_device': typeof AdminADevicesDeviceIdDeviceRouteWithChildren
  '/_admin/a/dns/_dns/extra-records': typeof AdminADnsDnsExtraRecordsRoute
  '/_admin/a/dns/_dns/global': typeof AdminADnsDnsGlobalRoute
  '/_admin/a/dns/_dns/search-domains': typeof AdminADnsDnsSearchDomainsRoute
  '/_admin/a/dns/_dns/split': typeof AdminADnsDnsSplitRoute
  '/_admin/a/exitnodes/_exitnodes/approved': typeof AdminAExitnodesExitnodesApprovedRoute
  '/_admin/a/exitnodes/_exitnodes/pending': typeof AdminAExitnodesExitnodesPendingRoute
  '/_admin/a/groups/$groupId': typeof AdminAGroupsGroupIdRouteWithChildren
  '/_admin/a/groups/$groupId/_group': typeof AdminAGroupsGroupIdGroupRouteWithChildren
  '/_admin/a/groups/_groups/ldap': typeof AdminAGroupsGroupsLdapRoute
  '/_admin/a/groups/_groups/local': typeof AdminAGroupsGroupsLocalRoute
  '/_admin/a/groups/_groups/scim': typeof AdminAGroupsGroupsScimRoute
  '/_admin/a/settings/_settings/general': typeof AdminASettingsSettingsGeneralRoute
  '/_admin/a/settings/_settings/ldap': typeof AdminASettingsSettingsLdapRoute
  '/_admin/a/settings/_settings/scim': typeof AdminASettingsSettingsScimRoute
  '/_admin/a/subnets/$subnetId': typeof AdminASubnetsSubnetIdRouteWithChildren
  '/_admin/a/subnets/$subnetId/_subnet': typeof AdminASubnetsSubnetIdSubnetRouteWithChildren
  '/_admin/a/subnets/_subnets/approved': typeof AdminASubnetsSubnetsApprovedRoute
  '/_admin/a/subnets/_subnets/pending': typeof AdminASubnetsSubnetsPendingRoute
  '/_admin/a/tags/$tagId': typeof AdminATagsTagIdRouteWithChildren
  '/_admin/a/tags/$tagId/_tags': typeof AdminATagsTagIdTagsRouteWithChildren
  '/_admin/a/users/$userId': typeof AdminAUsersUserIdRouteWithChildren
  '/_admin/a/users/$userId/_user': typeof AdminAUsersUserIdUserRouteWithChildren
  '/_customer/c/devices/$deviceId': typeof CustomerCDevicesDeviceIdRouteWithChildren
  '/_customer/c/devices/$deviceId/_device': typeof CustomerCDevicesDeviceIdDeviceRouteWithChildren
  '/_customer/c/exitnodes/_exitnodes/approved': typeof CustomerCExitnodesExitnodesApprovedRoute
  '/_customer/c/exitnodes/_exitnodes/pending': typeof CustomerCExitnodesExitnodesPendingRoute
  '/_customer/c/groups/$groupId': typeof CustomerCGroupsGroupIdRouteWithChildren
  '/_customer/c/groups/$groupId/_group': typeof CustomerCGroupsGroupIdGroupRouteWithChildren
  '/_customer/c/groups/_groups/ldap': typeof CustomerCGroupsGroupsLdapRoute
  '/_customer/c/groups/_groups/local': typeof CustomerCGroupsGroupsLocalRoute
  '/_customer/c/groups/_groups/scim': typeof CustomerCGroupsGroupsScimRoute
  '/_customer/c/subnets/$subnetId': typeof CustomerCSubnetsSubnetIdRouteWithChildren
  '/_customer/c/subnets/$subnetId/_subnet': typeof CustomerCSubnetsSubnetIdSubnetRouteWithChildren
  '/_customer/c/subnets/_subnets/approved': typeof CustomerCSubnetsSubnetsApprovedRoute
  '/_customer/c/subnets/_subnets/pending': typeof CustomerCSubnetsSubnetsPendingRoute
  '/_customer/c/tags/$tagId': typeof CustomerCTagsTagIdRouteWithChildren
  '/_customer/c/tags/$tagId/_tags': typeof CustomerCTagsTagIdTagsRouteWithChildren
  '/_customer/c/users/$userId': typeof CustomerCUsersUserIdRouteWithChildren
  '/_customer/c/users/$userId/_user': typeof CustomerCUsersUserIdUserRouteWithChildren
  '/_static/s/tailscale-login/$token/external-tailscale-login': typeof StaticSTailscaleLoginTokenExternalTailscaleLoginRoute
  '/_static/s/tailscale-login/$token/': typeof StaticSTailscaleLoginTokenIndexRoute
  '/_admin/a/devices/$deviceId/_device/general': typeof AdminADevicesDeviceIdDeviceGeneralRoute
  '/_admin/a/devices/$deviceId/_device/inbound-acls': typeof AdminADevicesDeviceIdDeviceInboundAclsRoute
  '/_admin/a/devices/$deviceId/_device/outbound-acls': typeof AdminADevicesDeviceIdDeviceOutboundAclsRoute
  '/_admin/a/groups/$groupId/_group/general': typeof AdminAGroupsGroupIdGroupGeneralRoute
  '/_admin/a/groups/$groupId/_group/inbound-acls': typeof AdminAGroupsGroupIdGroupInboundAclsRoute
  '/_admin/a/groups/$groupId/_group/outbound-acls': typeof AdminAGroupsGroupIdGroupOutboundAclsRoute
  '/_admin/a/settings/_settings/oidc/trufflepig': typeof AdminASettingsSettingsOidcTrufflepigRoute
  '/_admin/a/subnets/$subnetId/_subnet/inbound-acls': typeof AdminASubnetsSubnetIdSubnetInboundAclsRoute
  '/_admin/a/subnets/$subnetId/_subnet/outbound-acls': typeof AdminASubnetsSubnetIdSubnetOutboundAclsRoute
  '/_admin/a/tags/$tagId/_tags/associated': typeof AdminATagsTagIdTagsAssociatedRoute
  '/_admin/a/tags/$tagId/_tags/inbound-acls': typeof AdminATagsTagIdTagsInboundAclsRoute
  '/_admin/a/tags/$tagId/_tags/outbound-acls': typeof AdminATagsTagIdTagsOutboundAclsRoute
  '/_admin/a/users/$userId/_user/general': typeof AdminAUsersUserIdUserGeneralRoute
  '/_customer/c/devices/$deviceId/_device/general': typeof CustomerCDevicesDeviceIdDeviceGeneralRoute
  '/_customer/c/devices/$deviceId/_device/inbound-acls': typeof CustomerCDevicesDeviceIdDeviceInboundAclsRoute
  '/_customer/c/devices/$deviceId/_device/outbound-acls': typeof CustomerCDevicesDeviceIdDeviceOutboundAclsRoute
  '/_customer/c/groups/$groupId/_group/general': typeof CustomerCGroupsGroupIdGroupGeneralRoute
  '/_customer/c/groups/$groupId/_group/inbound-acls': typeof CustomerCGroupsGroupIdGroupInboundAclsRoute
  '/_customer/c/groups/$groupId/_group/outbound-acls': typeof CustomerCGroupsGroupIdGroupOutboundAclsRoute
  '/_customer/c/subnets/$subnetId/_subnet/inbound-acls': typeof CustomerCSubnetsSubnetIdSubnetInboundAclsRoute
  '/_customer/c/subnets/$subnetId/_subnet/outbound-acls': typeof CustomerCSubnetsSubnetIdSubnetOutboundAclsRoute
  '/_customer/c/tags/$tagId/_tags/associated': typeof CustomerCTagsTagIdTagsAssociatedRoute
  '/_customer/c/tags/$tagId/_tags/inbound-acls': typeof CustomerCTagsTagIdTagsInboundAclsRoute
  '/_customer/c/tags/$tagId/_tags/outbound-acls': typeof CustomerCTagsTagIdTagsOutboundAclsRoute
  '/_customer/c/users/$userId/_user/general': typeof CustomerCUsersUserIdUserGeneralRoute
  '/_admin/a/settings/_settings/oidc/': typeof AdminASettingsSettingsOidcIndexRoute
  '/_admin/a/settings/_settings/oidc/customer/admin': typeof AdminASettingsSettingsOidcCustomerAdminRoute
  '/_admin/a/settings/_settings/oidc/customer/vpn': typeof AdminASettingsSettingsOidcCustomerVpnRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/a/devices/create-server'
    | '/a/dns'
    | '/a/exitnodes'
    | '/a/groups'
    | '/a/settings'
    | '/a/subnets'
    | '/c/exitnodes'
    | '/c/groups'
    | '/c/subnets'
    | '/s/tailscale-login/disabled'
    | '/s/tailscale-login/invalid-csrf'
    | '/s/tailscale-login/outdated'
    | '/s/tailscale-login/server-error'
    | '/s/tailscale-login/success'
    | '/a/accounts'
    | '/a/dashboard'
    | '/a/devices'
    | '/a/dns/'
    | '/a/exitnodes/'
    | '/a/groups/'
    | '/a/logs'
    | '/a/preauthkeys'
    | '/a/profile'
    | '/a/settings/'
    | '/a/subnets/'
    | '/a/tags'
    | '/a/users'
    | '/c/dashboard'
    | '/c/devices'
    | '/c/exitnodes/'
    | '/c/groups/'
    | '/c/logs'
    | '/c/profile'
    | '/c/subnets/'
    | '/c/tags'
    | '/c/users'
    | '/a/devices/$deviceId'
    | '/a/dns/extra-records'
    | '/a/dns/global'
    | '/a/dns/search-domains'
    | '/a/dns/split'
    | '/a/exitnodes/approved'
    | '/a/exitnodes/pending'
    | '/a/groups/$groupId'
    | '/a/groups/ldap'
    | '/a/groups/local'
    | '/a/groups/scim'
    | '/a/settings/general'
    | '/a/settings/ldap'
    | '/a/settings/scim'
    | '/a/subnets/$subnetId'
    | '/a/subnets/approved'
    | '/a/subnets/pending'
    | '/a/tags/$tagId'
    | '/a/users/$userId'
    | '/c/devices/$deviceId'
    | '/c/exitnodes/approved'
    | '/c/exitnodes/pending'
    | '/c/groups/$groupId'
    | '/c/groups/ldap'
    | '/c/groups/local'
    | '/c/groups/scim'
    | '/c/subnets/$subnetId'
    | '/c/subnets/approved'
    | '/c/subnets/pending'
    | '/c/tags/$tagId'
    | '/c/users/$userId'
    | '/s/tailscale-login/$token/external-tailscale-login'
    | '/s/tailscale-login/$token'
    | '/a/devices/$deviceId/general'
    | '/a/devices/$deviceId/inbound-acls'
    | '/a/devices/$deviceId/outbound-acls'
    | '/a/groups/$groupId/general'
    | '/a/groups/$groupId/inbound-acls'
    | '/a/groups/$groupId/outbound-acls'
    | '/a/settings/oidc/trufflepig'
    | '/a/subnets/$subnetId/inbound-acls'
    | '/a/subnets/$subnetId/outbound-acls'
    | '/a/tags/$tagId/associated'
    | '/a/tags/$tagId/inbound-acls'
    | '/a/tags/$tagId/outbound-acls'
    | '/a/users/$userId/general'
    | '/c/devices/$deviceId/general'
    | '/c/devices/$deviceId/inbound-acls'
    | '/c/devices/$deviceId/outbound-acls'
    | '/c/groups/$groupId/general'
    | '/c/groups/$groupId/inbound-acls'
    | '/c/groups/$groupId/outbound-acls'
    | '/c/subnets/$subnetId/inbound-acls'
    | '/c/subnets/$subnetId/outbound-acls'
    | '/c/tags/$tagId/associated'
    | '/c/tags/$tagId/inbound-acls'
    | '/c/tags/$tagId/outbound-acls'
    | '/c/users/$userId/general'
    | '/a/settings/oidc'
    | '/a/settings/oidc/customer/admin'
    | '/a/settings/oidc/customer/vpn'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/a/devices/create-server'
    | '/a/dns'
    | '/a/exitnodes'
    | '/a/groups'
    | '/a/settings'
    | '/a/subnets'
    | '/c/exitnodes'
    | '/c/groups'
    | '/c/subnets'
    | '/s/tailscale-login/disabled'
    | '/s/tailscale-login/invalid-csrf'
    | '/s/tailscale-login/outdated'
    | '/s/tailscale-login/server-error'
    | '/s/tailscale-login/success'
    | '/a/accounts'
    | '/a/dashboard'
    | '/a/devices'
    | '/a/logs'
    | '/a/preauthkeys'
    | '/a/profile'
    | '/a/tags'
    | '/a/users'
    | '/c/dashboard'
    | '/c/devices'
    | '/c/logs'
    | '/c/profile'
    | '/c/tags'
    | '/c/users'
    | '/a/devices/$deviceId'
    | '/a/dns/extra-records'
    | '/a/dns/global'
    | '/a/dns/search-domains'
    | '/a/dns/split'
    | '/a/exitnodes/approved'
    | '/a/exitnodes/pending'
    | '/a/groups/$groupId'
    | '/a/groups/ldap'
    | '/a/groups/local'
    | '/a/groups/scim'
    | '/a/settings/general'
    | '/a/settings/ldap'
    | '/a/settings/scim'
    | '/a/subnets/$subnetId'
    | '/a/subnets/approved'
    | '/a/subnets/pending'
    | '/a/tags/$tagId'
    | '/a/users/$userId'
    | '/c/devices/$deviceId'
    | '/c/exitnodes/approved'
    | '/c/exitnodes/pending'
    | '/c/groups/$groupId'
    | '/c/groups/ldap'
    | '/c/groups/local'
    | '/c/groups/scim'
    | '/c/subnets/$subnetId'
    | '/c/subnets/approved'
    | '/c/subnets/pending'
    | '/c/tags/$tagId'
    | '/c/users/$userId'
    | '/s/tailscale-login/$token/external-tailscale-login'
    | '/s/tailscale-login/$token'
    | '/a/devices/$deviceId/general'
    | '/a/devices/$deviceId/inbound-acls'
    | '/a/devices/$deviceId/outbound-acls'
    | '/a/groups/$groupId/general'
    | '/a/groups/$groupId/inbound-acls'
    | '/a/groups/$groupId/outbound-acls'
    | '/a/settings/oidc/trufflepig'
    | '/a/subnets/$subnetId/inbound-acls'
    | '/a/subnets/$subnetId/outbound-acls'
    | '/a/tags/$tagId/associated'
    | '/a/tags/$tagId/inbound-acls'
    | '/a/tags/$tagId/outbound-acls'
    | '/a/users/$userId/general'
    | '/c/devices/$deviceId/general'
    | '/c/devices/$deviceId/inbound-acls'
    | '/c/devices/$deviceId/outbound-acls'
    | '/c/groups/$groupId/general'
    | '/c/groups/$groupId/inbound-acls'
    | '/c/groups/$groupId/outbound-acls'
    | '/c/subnets/$subnetId/inbound-acls'
    | '/c/subnets/$subnetId/outbound-acls'
    | '/c/tags/$tagId/associated'
    | '/c/tags/$tagId/inbound-acls'
    | '/c/tags/$tagId/outbound-acls'
    | '/c/users/$userId/general'
    | '/a/settings/oidc'
    | '/a/settings/oidc/customer/admin'
    | '/a/settings/oidc/customer/vpn'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/_customer'
    | '/_static'
    | '/_admin/a/devices/create-server'
    | '/_admin/a/dns'
    | '/_admin/a/dns/_dns'
    | '/_admin/a/exitnodes'
    | '/_admin/a/exitnodes/_exitnodes'
    | '/_admin/a/groups'
    | '/_admin/a/groups/_groups'
    | '/_admin/a/settings'
    | '/_admin/a/settings/_settings'
    | '/_admin/a/subnets'
    | '/_admin/a/subnets/_subnets'
    | '/_customer/c/exitnodes'
    | '/_customer/c/exitnodes/_exitnodes'
    | '/_customer/c/groups'
    | '/_customer/c/groups/_groups'
    | '/_customer/c/subnets'
    | '/_customer/c/subnets/_subnets'
    | '/_static/s/tailscale-login/disabled'
    | '/_static/s/tailscale-login/invalid-csrf'
    | '/_static/s/tailscale-login/outdated'
    | '/_static/s/tailscale-login/server-error'
    | '/_static/s/tailscale-login/success'
    | '/_admin/a/accounts/'
    | '/_admin/a/dashboard/'
    | '/_admin/a/devices/'
    | '/_admin/a/dns/'
    | '/_admin/a/exitnodes/'
    | '/_admin/a/groups/'
    | '/_admin/a/logs/'
    | '/_admin/a/preauthkeys/'
    | '/_admin/a/profile/'
    | '/_admin/a/settings/'
    | '/_admin/a/subnets/'
    | '/_admin/a/tags/'
    | '/_admin/a/users/'
    | '/_customer/c/dashboard/'
    | '/_customer/c/devices/'
    | '/_customer/c/exitnodes/'
    | '/_customer/c/groups/'
    | '/_customer/c/logs/'
    | '/_customer/c/profile/'
    | '/_customer/c/subnets/'
    | '/_customer/c/tags/'
    | '/_customer/c/users/'
    | '/_admin/a/devices/$deviceId'
    | '/_admin/a/devices/$deviceId/_device'
    | '/_admin/a/dns/_dns/extra-records'
    | '/_admin/a/dns/_dns/global'
    | '/_admin/a/dns/_dns/search-domains'
    | '/_admin/a/dns/_dns/split'
    | '/_admin/a/exitnodes/_exitnodes/approved'
    | '/_admin/a/exitnodes/_exitnodes/pending'
    | '/_admin/a/groups/$groupId'
    | '/_admin/a/groups/$groupId/_group'
    | '/_admin/a/groups/_groups/ldap'
    | '/_admin/a/groups/_groups/local'
    | '/_admin/a/groups/_groups/scim'
    | '/_admin/a/settings/_settings/general'
    | '/_admin/a/settings/_settings/ldap'
    | '/_admin/a/settings/_settings/scim'
    | '/_admin/a/subnets/$subnetId'
    | '/_admin/a/subnets/$subnetId/_subnet'
    | '/_admin/a/subnets/_subnets/approved'
    | '/_admin/a/subnets/_subnets/pending'
    | '/_admin/a/tags/$tagId'
    | '/_admin/a/tags/$tagId/_tags'
    | '/_admin/a/users/$userId'
    | '/_admin/a/users/$userId/_user'
    | '/_customer/c/devices/$deviceId'
    | '/_customer/c/devices/$deviceId/_device'
    | '/_customer/c/exitnodes/_exitnodes/approved'
    | '/_customer/c/exitnodes/_exitnodes/pending'
    | '/_customer/c/groups/$groupId'
    | '/_customer/c/groups/$groupId/_group'
    | '/_customer/c/groups/_groups/ldap'
    | '/_customer/c/groups/_groups/local'
    | '/_customer/c/groups/_groups/scim'
    | '/_customer/c/subnets/$subnetId'
    | '/_customer/c/subnets/$subnetId/_subnet'
    | '/_customer/c/subnets/_subnets/approved'
    | '/_customer/c/subnets/_subnets/pending'
    | '/_customer/c/tags/$tagId'
    | '/_customer/c/tags/$tagId/_tags'
    | '/_customer/c/users/$userId'
    | '/_customer/c/users/$userId/_user'
    | '/_static/s/tailscale-login/$token/external-tailscale-login'
    | '/_static/s/tailscale-login/$token/'
    | '/_admin/a/devices/$deviceId/_device/general'
    | '/_admin/a/devices/$deviceId/_device/inbound-acls'
    | '/_admin/a/devices/$deviceId/_device/outbound-acls'
    | '/_admin/a/groups/$groupId/_group/general'
    | '/_admin/a/groups/$groupId/_group/inbound-acls'
    | '/_admin/a/groups/$groupId/_group/outbound-acls'
    | '/_admin/a/settings/_settings/oidc/trufflepig'
    | '/_admin/a/subnets/$subnetId/_subnet/inbound-acls'
    | '/_admin/a/subnets/$subnetId/_subnet/outbound-acls'
    | '/_admin/a/tags/$tagId/_tags/associated'
    | '/_admin/a/tags/$tagId/_tags/inbound-acls'
    | '/_admin/a/tags/$tagId/_tags/outbound-acls'
    | '/_admin/a/users/$userId/_user/general'
    | '/_customer/c/devices/$deviceId/_device/general'
    | '/_customer/c/devices/$deviceId/_device/inbound-acls'
    | '/_customer/c/devices/$deviceId/_device/outbound-acls'
    | '/_customer/c/groups/$groupId/_group/general'
    | '/_customer/c/groups/$groupId/_group/inbound-acls'
    | '/_customer/c/groups/$groupId/_group/outbound-acls'
    | '/_customer/c/subnets/$subnetId/_subnet/inbound-acls'
    | '/_customer/c/subnets/$subnetId/_subnet/outbound-acls'
    | '/_customer/c/tags/$tagId/_tags/associated'
    | '/_customer/c/tags/$tagId/_tags/inbound-acls'
    | '/_customer/c/tags/$tagId/_tags/outbound-acls'
    | '/_customer/c/users/$userId/_user/general'
    | '/_admin/a/settings/_settings/oidc/'
    | '/_admin/a/settings/_settings/oidc/customer/admin'
    | '/_admin/a/settings/_settings/oidc/customer/vpn'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminLazyRoute: typeof AdminLazyRouteWithChildren
  CustomerLazyRoute: typeof CustomerLazyRouteWithChildren
  StaticLazyRoute: typeof StaticLazyRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_static': {
      id: '/_static'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof StaticLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_customer': {
      id: '/_customer'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof CustomerLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AdminLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_customer/c/subnets': {
      id: '/_customer/c/subnets'
      path: '/c/subnets'
      fullPath: '/c/subnets'
      preLoaderRoute: typeof CustomerCSubnetsRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_customer/c/groups': {
      id: '/_customer/c/groups'
      path: '/c/groups'
      fullPath: '/c/groups'
      preLoaderRoute: typeof CustomerCGroupsRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_customer/c/exitnodes': {
      id: '/_customer/c/exitnodes'
      path: '/c/exitnodes'
      fullPath: '/c/exitnodes'
      preLoaderRoute: typeof CustomerCExitnodesRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_admin/a/subnets': {
      id: '/_admin/a/subnets'
      path: '/a/subnets'
      fullPath: '/a/subnets'
      preLoaderRoute: typeof AdminASubnetsRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/settings': {
      id: '/_admin/a/settings'
      path: '/a/settings'
      fullPath: '/a/settings'
      preLoaderRoute: typeof AdminASettingsRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/groups': {
      id: '/_admin/a/groups'
      path: '/a/groups'
      fullPath: '/a/groups'
      preLoaderRoute: typeof AdminAGroupsRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/exitnodes': {
      id: '/_admin/a/exitnodes'
      path: '/a/exitnodes'
      fullPath: '/a/exitnodes'
      preLoaderRoute: typeof AdminAExitnodesRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/dns': {
      id: '/_admin/a/dns'
      path: '/a/dns'
      fullPath: '/a/dns'
      preLoaderRoute: typeof AdminADnsRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_customer/c/users/$userId': {
      id: '/_customer/c/users/$userId'
      path: '/c/users/$userId'
      fullPath: '/c/users/$userId'
      preLoaderRoute: typeof CustomerCUsersUserIdRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_customer/c/tags/$tagId': {
      id: '/_customer/c/tags/$tagId'
      path: '/c/tags/$tagId'
      fullPath: '/c/tags/$tagId'
      preLoaderRoute: typeof CustomerCTagsTagIdRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_customer/c/subnets/$subnetId': {
      id: '/_customer/c/subnets/$subnetId'
      path: '/$subnetId'
      fullPath: '/c/subnets/$subnetId'
      preLoaderRoute: typeof CustomerCSubnetsSubnetIdRouteImport
      parentRoute: typeof CustomerCSubnetsRoute
    }
    '/_customer/c/groups/$groupId': {
      id: '/_customer/c/groups/$groupId'
      path: '/$groupId'
      fullPath: '/c/groups/$groupId'
      preLoaderRoute: typeof CustomerCGroupsGroupIdRouteImport
      parentRoute: typeof CustomerCGroupsRoute
    }
    '/_customer/c/devices/$deviceId': {
      id: '/_customer/c/devices/$deviceId'
      path: '/c/devices/$deviceId'
      fullPath: '/c/devices/$deviceId'
      preLoaderRoute: typeof CustomerCDevicesDeviceIdRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_admin/a/users/$userId': {
      id: '/_admin/a/users/$userId'
      path: '/a/users/$userId'
      fullPath: '/a/users/$userId'
      preLoaderRoute: typeof AdminAUsersUserIdRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/tags/$tagId': {
      id: '/_admin/a/tags/$tagId'
      path: '/a/tags/$tagId'
      fullPath: '/a/tags/$tagId'
      preLoaderRoute: typeof AdminATagsTagIdRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/subnets/$subnetId': {
      id: '/_admin/a/subnets/$subnetId'
      path: '/$subnetId'
      fullPath: '/a/subnets/$subnetId'
      preLoaderRoute: typeof AdminASubnetsSubnetIdRouteImport
      parentRoute: typeof AdminASubnetsRoute
    }
    '/_admin/a/groups/$groupId': {
      id: '/_admin/a/groups/$groupId'
      path: '/$groupId'
      fullPath: '/a/groups/$groupId'
      preLoaderRoute: typeof AdminAGroupsGroupIdRouteImport
      parentRoute: typeof AdminAGroupsRoute
    }
    '/_admin/a/devices/$deviceId': {
      id: '/_admin/a/devices/$deviceId'
      path: '/a/devices/$deviceId'
      fullPath: '/a/devices/$deviceId'
      preLoaderRoute: typeof AdminADevicesDeviceIdRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_customer/c/users/': {
      id: '/_customer/c/users/'
      path: '/c/users'
      fullPath: '/c/users'
      preLoaderRoute: typeof CustomerCUsersIndexRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_customer/c/tags/': {
      id: '/_customer/c/tags/'
      path: '/c/tags'
      fullPath: '/c/tags'
      preLoaderRoute: typeof CustomerCTagsIndexRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_customer/c/subnets/': {
      id: '/_customer/c/subnets/'
      path: '/'
      fullPath: '/c/subnets/'
      preLoaderRoute: typeof CustomerCSubnetsIndexRouteImport
      parentRoute: typeof CustomerCSubnetsRoute
    }
    '/_customer/c/profile/': {
      id: '/_customer/c/profile/'
      path: '/c/profile'
      fullPath: '/c/profile'
      preLoaderRoute: typeof CustomerCProfileIndexRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_customer/c/logs/': {
      id: '/_customer/c/logs/'
      path: '/c/logs'
      fullPath: '/c/logs'
      preLoaderRoute: typeof CustomerCLogsIndexRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_customer/c/groups/': {
      id: '/_customer/c/groups/'
      path: '/'
      fullPath: '/c/groups/'
      preLoaderRoute: typeof CustomerCGroupsIndexRouteImport
      parentRoute: typeof CustomerCGroupsRoute
    }
    '/_customer/c/exitnodes/': {
      id: '/_customer/c/exitnodes/'
      path: '/'
      fullPath: '/c/exitnodes/'
      preLoaderRoute: typeof CustomerCExitnodesIndexRouteImport
      parentRoute: typeof CustomerCExitnodesRoute
    }
    '/_customer/c/devices/': {
      id: '/_customer/c/devices/'
      path: '/c/devices'
      fullPath: '/c/devices'
      preLoaderRoute: typeof CustomerCDevicesIndexRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_customer/c/dashboard/': {
      id: '/_customer/c/dashboard/'
      path: '/c/dashboard'
      fullPath: '/c/dashboard'
      preLoaderRoute: typeof CustomerCDashboardIndexRouteImport
      parentRoute: typeof CustomerLazyRoute
    }
    '/_admin/a/users/': {
      id: '/_admin/a/users/'
      path: '/a/users'
      fullPath: '/a/users'
      preLoaderRoute: typeof AdminAUsersIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/tags/': {
      id: '/_admin/a/tags/'
      path: '/a/tags'
      fullPath: '/a/tags'
      preLoaderRoute: typeof AdminATagsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/subnets/': {
      id: '/_admin/a/subnets/'
      path: '/'
      fullPath: '/a/subnets/'
      preLoaderRoute: typeof AdminASubnetsIndexRouteImport
      parentRoute: typeof AdminASubnetsRoute
    }
    '/_admin/a/settings/': {
      id: '/_admin/a/settings/'
      path: '/'
      fullPath: '/a/settings/'
      preLoaderRoute: typeof AdminASettingsIndexRouteImport
      parentRoute: typeof AdminASettingsRoute
    }
    '/_admin/a/profile/': {
      id: '/_admin/a/profile/'
      path: '/a/profile'
      fullPath: '/a/profile'
      preLoaderRoute: typeof AdminAProfileIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/preauthkeys/': {
      id: '/_admin/a/preauthkeys/'
      path: '/a/preauthkeys'
      fullPath: '/a/preauthkeys'
      preLoaderRoute: typeof AdminAPreauthkeysIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/logs/': {
      id: '/_admin/a/logs/'
      path: '/a/logs'
      fullPath: '/a/logs'
      preLoaderRoute: typeof AdminALogsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/groups/': {
      id: '/_admin/a/groups/'
      path: '/'
      fullPath: '/a/groups/'
      preLoaderRoute: typeof AdminAGroupsIndexRouteImport
      parentRoute: typeof AdminAGroupsRoute
    }
    '/_admin/a/exitnodes/': {
      id: '/_admin/a/exitnodes/'
      path: '/'
      fullPath: '/a/exitnodes/'
      preLoaderRoute: typeof AdminAExitnodesIndexRouteImport
      parentRoute: typeof AdminAExitnodesRoute
    }
    '/_admin/a/dns/': {
      id: '/_admin/a/dns/'
      path: '/'
      fullPath: '/a/dns/'
      preLoaderRoute: typeof AdminADnsIndexRouteImport
      parentRoute: typeof AdminADnsRoute
    }
    '/_admin/a/devices/': {
      id: '/_admin/a/devices/'
      path: '/a/devices'
      fullPath: '/a/devices'
      preLoaderRoute: typeof AdminADevicesIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/dashboard/': {
      id: '/_admin/a/dashboard/'
      path: '/a/dashboard'
      fullPath: '/a/dashboard'
      preLoaderRoute: typeof AdminADashboardIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/accounts/': {
      id: '/_admin/a/accounts/'
      path: '/a/accounts'
      fullPath: '/a/accounts'
      preLoaderRoute: typeof AdminAAccountsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_static/s/tailscale-login/success': {
      id: '/_static/s/tailscale-login/success'
      path: '/s/tailscale-login/success'
      fullPath: '/s/tailscale-login/success'
      preLoaderRoute: typeof StaticSTailscaleLoginSuccessRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/tailscale-login/server-error': {
      id: '/_static/s/tailscale-login/server-error'
      path: '/s/tailscale-login/server-error'
      fullPath: '/s/tailscale-login/server-error'
      preLoaderRoute: typeof StaticSTailscaleLoginServerErrorRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/tailscale-login/outdated': {
      id: '/_static/s/tailscale-login/outdated'
      path: '/s/tailscale-login/outdated'
      fullPath: '/s/tailscale-login/outdated'
      preLoaderRoute: typeof StaticSTailscaleLoginOutdatedRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/tailscale-login/invalid-csrf': {
      id: '/_static/s/tailscale-login/invalid-csrf'
      path: '/s/tailscale-login/invalid-csrf'
      fullPath: '/s/tailscale-login/invalid-csrf'
      preLoaderRoute: typeof StaticSTailscaleLoginInvalidCsrfRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/tailscale-login/disabled': {
      id: '/_static/s/tailscale-login/disabled'
      path: '/s/tailscale-login/disabled'
      fullPath: '/s/tailscale-login/disabled'
      preLoaderRoute: typeof StaticSTailscaleLoginDisabledRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_customer/c/subnets/_subnets': {
      id: '/_customer/c/subnets/_subnets'
      path: '/c/subnets'
      fullPath: '/c/subnets'
      preLoaderRoute: typeof CustomerCSubnetsSubnetsRouteImport
      parentRoute: typeof CustomerCSubnetsRoute
    }
    '/_customer/c/groups/_groups': {
      id: '/_customer/c/groups/_groups'
      path: '/c/groups'
      fullPath: '/c/groups'
      preLoaderRoute: typeof CustomerCGroupsGroupsRouteImport
      parentRoute: typeof CustomerCGroupsRoute
    }
    '/_customer/c/exitnodes/_exitnodes': {
      id: '/_customer/c/exitnodes/_exitnodes'
      path: '/c/exitnodes'
      fullPath: '/c/exitnodes'
      preLoaderRoute: typeof CustomerCExitnodesExitnodesRouteImport
      parentRoute: typeof CustomerCExitnodesRoute
    }
    '/_admin/a/subnets/_subnets': {
      id: '/_admin/a/subnets/_subnets'
      path: '/a/subnets'
      fullPath: '/a/subnets'
      preLoaderRoute: typeof AdminASubnetsSubnetsRouteImport
      parentRoute: typeof AdminASubnetsRoute
    }
    '/_admin/a/settings/_settings': {
      id: '/_admin/a/settings/_settings'
      path: '/a/settings'
      fullPath: '/a/settings'
      preLoaderRoute: typeof AdminASettingsSettingsRouteImport
      parentRoute: typeof AdminASettingsRoute
    }
    '/_admin/a/groups/_groups': {
      id: '/_admin/a/groups/_groups'
      path: '/a/groups'
      fullPath: '/a/groups'
      preLoaderRoute: typeof AdminAGroupsGroupsRouteImport
      parentRoute: typeof AdminAGroupsRoute
    }
    '/_admin/a/exitnodes/_exitnodes': {
      id: '/_admin/a/exitnodes/_exitnodes'
      path: '/a/exitnodes'
      fullPath: '/a/exitnodes'
      preLoaderRoute: typeof AdminAExitnodesExitnodesRouteImport
      parentRoute: typeof AdminAExitnodesRoute
    }
    '/_admin/a/dns/_dns': {
      id: '/_admin/a/dns/_dns'
      path: '/a/dns'
      fullPath: '/a/dns'
      preLoaderRoute: typeof AdminADnsDnsRouteImport
      parentRoute: typeof AdminADnsRoute
    }
    '/_admin/a/devices/create-server': {
      id: '/_admin/a/devices/create-server'
      path: '/a/devices/create-server'
      fullPath: '/a/devices/create-server'
      preLoaderRoute: typeof AdminADevicesCreateServerRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_static/s/tailscale-login/$token/': {
      id: '/_static/s/tailscale-login/$token/'
      path: '/s/tailscale-login/$token'
      fullPath: '/s/tailscale-login/$token'
      preLoaderRoute: typeof StaticSTailscaleLoginTokenIndexRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/tailscale-login/$token/external-tailscale-login': {
      id: '/_static/s/tailscale-login/$token/external-tailscale-login'
      path: '/s/tailscale-login/$token/external-tailscale-login'
      fullPath: '/s/tailscale-login/$token/external-tailscale-login'
      preLoaderRoute: typeof StaticSTailscaleLoginTokenExternalTailscaleLoginRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_customer/c/users/$userId/_user': {
      id: '/_customer/c/users/$userId/_user'
      path: '/c/users/$userId'
      fullPath: '/c/users/$userId'
      preLoaderRoute: typeof CustomerCUsersUserIdUserRouteImport
      parentRoute: typeof CustomerCUsersUserIdRoute
    }
    '/_customer/c/tags/$tagId/_tags': {
      id: '/_customer/c/tags/$tagId/_tags'
      path: '/c/tags/$tagId'
      fullPath: '/c/tags/$tagId'
      preLoaderRoute: typeof CustomerCTagsTagIdTagsRouteImport
      parentRoute: typeof CustomerCTagsTagIdRoute
    }
    '/_customer/c/subnets/_subnets/pending': {
      id: '/_customer/c/subnets/_subnets/pending'
      path: '/pending'
      fullPath: '/c/subnets/pending'
      preLoaderRoute: typeof CustomerCSubnetsSubnetsPendingRouteImport
      parentRoute: typeof CustomerCSubnetsSubnetsRoute
    }
    '/_customer/c/subnets/_subnets/approved': {
      id: '/_customer/c/subnets/_subnets/approved'
      path: '/approved'
      fullPath: '/c/subnets/approved'
      preLoaderRoute: typeof CustomerCSubnetsSubnetsApprovedRouteImport
      parentRoute: typeof CustomerCSubnetsSubnetsRoute
    }
    '/_customer/c/subnets/$subnetId/_subnet': {
      id: '/_customer/c/subnets/$subnetId/_subnet'
      path: '/$subnetId'
      fullPath: '/c/subnets/$subnetId'
      preLoaderRoute: typeof CustomerCSubnetsSubnetIdSubnetRouteImport
      parentRoute: typeof CustomerCSubnetsSubnetIdRoute
    }
    '/_customer/c/groups/_groups/scim': {
      id: '/_customer/c/groups/_groups/scim'
      path: '/scim'
      fullPath: '/c/groups/scim'
      preLoaderRoute: typeof CustomerCGroupsGroupsScimRouteImport
      parentRoute: typeof CustomerCGroupsGroupsRoute
    }
    '/_customer/c/groups/_groups/local': {
      id: '/_customer/c/groups/_groups/local'
      path: '/local'
      fullPath: '/c/groups/local'
      preLoaderRoute: typeof CustomerCGroupsGroupsLocalRouteImport
      parentRoute: typeof CustomerCGroupsGroupsRoute
    }
    '/_customer/c/groups/_groups/ldap': {
      id: '/_customer/c/groups/_groups/ldap'
      path: '/ldap'
      fullPath: '/c/groups/ldap'
      preLoaderRoute: typeof CustomerCGroupsGroupsLdapRouteImport
      parentRoute: typeof CustomerCGroupsGroupsRoute
    }
    '/_customer/c/groups/$groupId/_group': {
      id: '/_customer/c/groups/$groupId/_group'
      path: '/$groupId'
      fullPath: '/c/groups/$groupId'
      preLoaderRoute: typeof CustomerCGroupsGroupIdGroupRouteImport
      parentRoute: typeof CustomerCGroupsGroupIdRoute
    }
    '/_customer/c/exitnodes/_exitnodes/pending': {
      id: '/_customer/c/exitnodes/_exitnodes/pending'
      path: '/pending'
      fullPath: '/c/exitnodes/pending'
      preLoaderRoute: typeof CustomerCExitnodesExitnodesPendingRouteImport
      parentRoute: typeof CustomerCExitnodesExitnodesRoute
    }
    '/_customer/c/exitnodes/_exitnodes/approved': {
      id: '/_customer/c/exitnodes/_exitnodes/approved'
      path: '/approved'
      fullPath: '/c/exitnodes/approved'
      preLoaderRoute: typeof CustomerCExitnodesExitnodesApprovedRouteImport
      parentRoute: typeof CustomerCExitnodesExitnodesRoute
    }
    '/_customer/c/devices/$deviceId/_device': {
      id: '/_customer/c/devices/$deviceId/_device'
      path: '/c/devices/$deviceId'
      fullPath: '/c/devices/$deviceId'
      preLoaderRoute: typeof CustomerCDevicesDeviceIdDeviceRouteImport
      parentRoute: typeof CustomerCDevicesDeviceIdRoute
    }
    '/_admin/a/users/$userId/_user': {
      id: '/_admin/a/users/$userId/_user'
      path: '/a/users/$userId'
      fullPath: '/a/users/$userId'
      preLoaderRoute: typeof AdminAUsersUserIdUserRouteImport
      parentRoute: typeof AdminAUsersUserIdRoute
    }
    '/_admin/a/tags/$tagId/_tags': {
      id: '/_admin/a/tags/$tagId/_tags'
      path: '/a/tags/$tagId'
      fullPath: '/a/tags/$tagId'
      preLoaderRoute: typeof AdminATagsTagIdTagsRouteImport
      parentRoute: typeof AdminATagsTagIdRoute
    }
    '/_admin/a/subnets/_subnets/pending': {
      id: '/_admin/a/subnets/_subnets/pending'
      path: '/pending'
      fullPath: '/a/subnets/pending'
      preLoaderRoute: typeof AdminASubnetsSubnetsPendingRouteImport
      parentRoute: typeof AdminASubnetsSubnetsRoute
    }
    '/_admin/a/subnets/_subnets/approved': {
      id: '/_admin/a/subnets/_subnets/approved'
      path: '/approved'
      fullPath: '/a/subnets/approved'
      preLoaderRoute: typeof AdminASubnetsSubnetsApprovedRouteImport
      parentRoute: typeof AdminASubnetsSubnetsRoute
    }
    '/_admin/a/subnets/$subnetId/_subnet': {
      id: '/_admin/a/subnets/$subnetId/_subnet'
      path: '/$subnetId'
      fullPath: '/a/subnets/$subnetId'
      preLoaderRoute: typeof AdminASubnetsSubnetIdSubnetRouteImport
      parentRoute: typeof AdminASubnetsSubnetIdRoute
    }
    '/_admin/a/settings/_settings/scim': {
      id: '/_admin/a/settings/_settings/scim'
      path: '/scim'
      fullPath: '/a/settings/scim'
      preLoaderRoute: typeof AdminASettingsSettingsScimRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
    '/_admin/a/settings/_settings/ldap': {
      id: '/_admin/a/settings/_settings/ldap'
      path: '/ldap'
      fullPath: '/a/settings/ldap'
      preLoaderRoute: typeof AdminASettingsSettingsLdapRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
    '/_admin/a/settings/_settings/general': {
      id: '/_admin/a/settings/_settings/general'
      path: '/general'
      fullPath: '/a/settings/general'
      preLoaderRoute: typeof AdminASettingsSettingsGeneralRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
    '/_admin/a/groups/_groups/scim': {
      id: '/_admin/a/groups/_groups/scim'
      path: '/scim'
      fullPath: '/a/groups/scim'
      preLoaderRoute: typeof AdminAGroupsGroupsScimRouteImport
      parentRoute: typeof AdminAGroupsGroupsRoute
    }
    '/_admin/a/groups/_groups/local': {
      id: '/_admin/a/groups/_groups/local'
      path: '/local'
      fullPath: '/a/groups/local'
      preLoaderRoute: typeof AdminAGroupsGroupsLocalRouteImport
      parentRoute: typeof AdminAGroupsGroupsRoute
    }
    '/_admin/a/groups/_groups/ldap': {
      id: '/_admin/a/groups/_groups/ldap'
      path: '/ldap'
      fullPath: '/a/groups/ldap'
      preLoaderRoute: typeof AdminAGroupsGroupsLdapRouteImport
      parentRoute: typeof AdminAGroupsGroupsRoute
    }
    '/_admin/a/groups/$groupId/_group': {
      id: '/_admin/a/groups/$groupId/_group'
      path: '/$groupId'
      fullPath: '/a/groups/$groupId'
      preLoaderRoute: typeof AdminAGroupsGroupIdGroupRouteImport
      parentRoute: typeof AdminAGroupsGroupIdRoute
    }
    '/_admin/a/exitnodes/_exitnodes/pending': {
      id: '/_admin/a/exitnodes/_exitnodes/pending'
      path: '/pending'
      fullPath: '/a/exitnodes/pending'
      preLoaderRoute: typeof AdminAExitnodesExitnodesPendingRouteImport
      parentRoute: typeof AdminAExitnodesExitnodesRoute
    }
    '/_admin/a/exitnodes/_exitnodes/approved': {
      id: '/_admin/a/exitnodes/_exitnodes/approved'
      path: '/approved'
      fullPath: '/a/exitnodes/approved'
      preLoaderRoute: typeof AdminAExitnodesExitnodesApprovedRouteImport
      parentRoute: typeof AdminAExitnodesExitnodesRoute
    }
    '/_admin/a/dns/_dns/split': {
      id: '/_admin/a/dns/_dns/split'
      path: '/split'
      fullPath: '/a/dns/split'
      preLoaderRoute: typeof AdminADnsDnsSplitRouteImport
      parentRoute: typeof AdminADnsDnsRoute
    }
    '/_admin/a/dns/_dns/search-domains': {
      id: '/_admin/a/dns/_dns/search-domains'
      path: '/search-domains'
      fullPath: '/a/dns/search-domains'
      preLoaderRoute: typeof AdminADnsDnsSearchDomainsRouteImport
      parentRoute: typeof AdminADnsDnsRoute
    }
    '/_admin/a/dns/_dns/global': {
      id: '/_admin/a/dns/_dns/global'
      path: '/global'
      fullPath: '/a/dns/global'
      preLoaderRoute: typeof AdminADnsDnsGlobalRouteImport
      parentRoute: typeof AdminADnsDnsRoute
    }
    '/_admin/a/dns/_dns/extra-records': {
      id: '/_admin/a/dns/_dns/extra-records'
      path: '/extra-records'
      fullPath: '/a/dns/extra-records'
      preLoaderRoute: typeof AdminADnsDnsExtraRecordsRouteImport
      parentRoute: typeof AdminADnsDnsRoute
    }
    '/_admin/a/devices/$deviceId/_device': {
      id: '/_admin/a/devices/$deviceId/_device'
      path: '/a/devices/$deviceId'
      fullPath: '/a/devices/$deviceId'
      preLoaderRoute: typeof AdminADevicesDeviceIdDeviceRouteImport
      parentRoute: typeof AdminADevicesDeviceIdRoute
    }
    '/_admin/a/settings/_settings/oidc/': {
      id: '/_admin/a/settings/_settings/oidc/'
      path: '/oidc'
      fullPath: '/a/settings/oidc'
      preLoaderRoute: typeof AdminASettingsSettingsOidcIndexRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
    '/_customer/c/users/$userId/_user/general': {
      id: '/_customer/c/users/$userId/_user/general'
      path: '/general'
      fullPath: '/c/users/$userId/general'
      preLoaderRoute: typeof CustomerCUsersUserIdUserGeneralRouteImport
      parentRoute: typeof CustomerCUsersUserIdUserRoute
    }
    '/_customer/c/tags/$tagId/_tags/outbound-acls': {
      id: '/_customer/c/tags/$tagId/_tags/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/c/tags/$tagId/outbound-acls'
      preLoaderRoute: typeof CustomerCTagsTagIdTagsOutboundAclsRouteImport
      parentRoute: typeof CustomerCTagsTagIdTagsRoute
    }
    '/_customer/c/tags/$tagId/_tags/inbound-acls': {
      id: '/_customer/c/tags/$tagId/_tags/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/c/tags/$tagId/inbound-acls'
      preLoaderRoute: typeof CustomerCTagsTagIdTagsInboundAclsRouteImport
      parentRoute: typeof CustomerCTagsTagIdTagsRoute
    }
    '/_customer/c/tags/$tagId/_tags/associated': {
      id: '/_customer/c/tags/$tagId/_tags/associated'
      path: '/associated'
      fullPath: '/c/tags/$tagId/associated'
      preLoaderRoute: typeof CustomerCTagsTagIdTagsAssociatedRouteImport
      parentRoute: typeof CustomerCTagsTagIdTagsRoute
    }
    '/_customer/c/subnets/$subnetId/_subnet/outbound-acls': {
      id: '/_customer/c/subnets/$subnetId/_subnet/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/c/subnets/$subnetId/outbound-acls'
      preLoaderRoute: typeof CustomerCSubnetsSubnetIdSubnetOutboundAclsRouteImport
      parentRoute: typeof CustomerCSubnetsSubnetIdSubnetRoute
    }
    '/_customer/c/subnets/$subnetId/_subnet/inbound-acls': {
      id: '/_customer/c/subnets/$subnetId/_subnet/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/c/subnets/$subnetId/inbound-acls'
      preLoaderRoute: typeof CustomerCSubnetsSubnetIdSubnetInboundAclsRouteImport
      parentRoute: typeof CustomerCSubnetsSubnetIdSubnetRoute
    }
    '/_customer/c/groups/$groupId/_group/outbound-acls': {
      id: '/_customer/c/groups/$groupId/_group/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/c/groups/$groupId/outbound-acls'
      preLoaderRoute: typeof CustomerCGroupsGroupIdGroupOutboundAclsRouteImport
      parentRoute: typeof CustomerCGroupsGroupIdGroupRoute
    }
    '/_customer/c/groups/$groupId/_group/inbound-acls': {
      id: '/_customer/c/groups/$groupId/_group/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/c/groups/$groupId/inbound-acls'
      preLoaderRoute: typeof CustomerCGroupsGroupIdGroupInboundAclsRouteImport
      parentRoute: typeof CustomerCGroupsGroupIdGroupRoute
    }
    '/_customer/c/groups/$groupId/_group/general': {
      id: '/_customer/c/groups/$groupId/_group/general'
      path: '/general'
      fullPath: '/c/groups/$groupId/general'
      preLoaderRoute: typeof CustomerCGroupsGroupIdGroupGeneralRouteImport
      parentRoute: typeof CustomerCGroupsGroupIdGroupRoute
    }
    '/_customer/c/devices/$deviceId/_device/outbound-acls': {
      id: '/_customer/c/devices/$deviceId/_device/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/c/devices/$deviceId/outbound-acls'
      preLoaderRoute: typeof CustomerCDevicesDeviceIdDeviceOutboundAclsRouteImport
      parentRoute: typeof CustomerCDevicesDeviceIdDeviceRoute
    }
    '/_customer/c/devices/$deviceId/_device/inbound-acls': {
      id: '/_customer/c/devices/$deviceId/_device/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/c/devices/$deviceId/inbound-acls'
      preLoaderRoute: typeof CustomerCDevicesDeviceIdDeviceInboundAclsRouteImport
      parentRoute: typeof CustomerCDevicesDeviceIdDeviceRoute
    }
    '/_customer/c/devices/$deviceId/_device/general': {
      id: '/_customer/c/devices/$deviceId/_device/general'
      path: '/general'
      fullPath: '/c/devices/$deviceId/general'
      preLoaderRoute: typeof CustomerCDevicesDeviceIdDeviceGeneralRouteImport
      parentRoute: typeof CustomerCDevicesDeviceIdDeviceRoute
    }
    '/_admin/a/users/$userId/_user/general': {
      id: '/_admin/a/users/$userId/_user/general'
      path: '/general'
      fullPath: '/a/users/$userId/general'
      preLoaderRoute: typeof AdminAUsersUserIdUserGeneralRouteImport
      parentRoute: typeof AdminAUsersUserIdUserRoute
    }
    '/_admin/a/tags/$tagId/_tags/outbound-acls': {
      id: '/_admin/a/tags/$tagId/_tags/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/a/tags/$tagId/outbound-acls'
      preLoaderRoute: typeof AdminATagsTagIdTagsOutboundAclsRouteImport
      parentRoute: typeof AdminATagsTagIdTagsRoute
    }
    '/_admin/a/tags/$tagId/_tags/inbound-acls': {
      id: '/_admin/a/tags/$tagId/_tags/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/a/tags/$tagId/inbound-acls'
      preLoaderRoute: typeof AdminATagsTagIdTagsInboundAclsRouteImport
      parentRoute: typeof AdminATagsTagIdTagsRoute
    }
    '/_admin/a/tags/$tagId/_tags/associated': {
      id: '/_admin/a/tags/$tagId/_tags/associated'
      path: '/associated'
      fullPath: '/a/tags/$tagId/associated'
      preLoaderRoute: typeof AdminATagsTagIdTagsAssociatedRouteImport
      parentRoute: typeof AdminATagsTagIdTagsRoute
    }
    '/_admin/a/subnets/$subnetId/_subnet/outbound-acls': {
      id: '/_admin/a/subnets/$subnetId/_subnet/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/a/subnets/$subnetId/outbound-acls'
      preLoaderRoute: typeof AdminASubnetsSubnetIdSubnetOutboundAclsRouteImport
      parentRoute: typeof AdminASubnetsSubnetIdSubnetRoute
    }
    '/_admin/a/subnets/$subnetId/_subnet/inbound-acls': {
      id: '/_admin/a/subnets/$subnetId/_subnet/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/a/subnets/$subnetId/inbound-acls'
      preLoaderRoute: typeof AdminASubnetsSubnetIdSubnetInboundAclsRouteImport
      parentRoute: typeof AdminASubnetsSubnetIdSubnetRoute
    }
    '/_admin/a/settings/_settings/oidc/trufflepig': {
      id: '/_admin/a/settings/_settings/oidc/trufflepig'
      path: '/oidc/trufflepig'
      fullPath: '/a/settings/oidc/trufflepig'
      preLoaderRoute: typeof AdminASettingsSettingsOidcTrufflepigRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
    '/_admin/a/groups/$groupId/_group/outbound-acls': {
      id: '/_admin/a/groups/$groupId/_group/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/a/groups/$groupId/outbound-acls'
      preLoaderRoute: typeof AdminAGroupsGroupIdGroupOutboundAclsRouteImport
      parentRoute: typeof AdminAGroupsGroupIdGroupRoute
    }
    '/_admin/a/groups/$groupId/_group/inbound-acls': {
      id: '/_admin/a/groups/$groupId/_group/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/a/groups/$groupId/inbound-acls'
      preLoaderRoute: typeof AdminAGroupsGroupIdGroupInboundAclsRouteImport
      parentRoute: typeof AdminAGroupsGroupIdGroupRoute
    }
    '/_admin/a/groups/$groupId/_group/general': {
      id: '/_admin/a/groups/$groupId/_group/general'
      path: '/general'
      fullPath: '/a/groups/$groupId/general'
      preLoaderRoute: typeof AdminAGroupsGroupIdGroupGeneralRouteImport
      parentRoute: typeof AdminAGroupsGroupIdGroupRoute
    }
    '/_admin/a/devices/$deviceId/_device/outbound-acls': {
      id: '/_admin/a/devices/$deviceId/_device/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/a/devices/$deviceId/outbound-acls'
      preLoaderRoute: typeof AdminADevicesDeviceIdDeviceOutboundAclsRouteImport
      parentRoute: typeof AdminADevicesDeviceIdDeviceRoute
    }
    '/_admin/a/devices/$deviceId/_device/inbound-acls': {
      id: '/_admin/a/devices/$deviceId/_device/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/a/devices/$deviceId/inbound-acls'
      preLoaderRoute: typeof AdminADevicesDeviceIdDeviceInboundAclsRouteImport
      parentRoute: typeof AdminADevicesDeviceIdDeviceRoute
    }
    '/_admin/a/devices/$deviceId/_device/general': {
      id: '/_admin/a/devices/$deviceId/_device/general'
      path: '/general'
      fullPath: '/a/devices/$deviceId/general'
      preLoaderRoute: typeof AdminADevicesDeviceIdDeviceGeneralRouteImport
      parentRoute: typeof AdminADevicesDeviceIdDeviceRoute
    }
    '/_admin/a/settings/_settings/oidc/customer/vpn': {
      id: '/_admin/a/settings/_settings/oidc/customer/vpn'
      path: '/oidc/customer/vpn'
      fullPath: '/a/settings/oidc/customer/vpn'
      preLoaderRoute: typeof AdminASettingsSettingsOidcCustomerVpnRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
    '/_admin/a/settings/_settings/oidc/customer/admin': {
      id: '/_admin/a/settings/_settings/oidc/customer/admin'
      path: '/oidc/customer/admin'
      fullPath: '/a/settings/oidc/customer/admin'
      preLoaderRoute: typeof AdminASettingsSettingsOidcCustomerAdminRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
  }
}

interface AdminADnsDnsRouteChildren {
  AdminADnsDnsExtraRecordsRoute: typeof AdminADnsDnsExtraRecordsRoute
  AdminADnsDnsGlobalRoute: typeof AdminADnsDnsGlobalRoute
  AdminADnsDnsSearchDomainsRoute: typeof AdminADnsDnsSearchDomainsRoute
  AdminADnsDnsSplitRoute: typeof AdminADnsDnsSplitRoute
}

const AdminADnsDnsRouteChildren: AdminADnsDnsRouteChildren = {
  AdminADnsDnsExtraRecordsRoute: AdminADnsDnsExtraRecordsRoute,
  AdminADnsDnsGlobalRoute: AdminADnsDnsGlobalRoute,
  AdminADnsDnsSearchDomainsRoute: AdminADnsDnsSearchDomainsRoute,
  AdminADnsDnsSplitRoute: AdminADnsDnsSplitRoute,
}

const AdminADnsDnsRouteWithChildren = AdminADnsDnsRoute._addFileChildren(
  AdminADnsDnsRouteChildren,
)

interface AdminADnsRouteChildren {
  AdminADnsDnsRoute: typeof AdminADnsDnsRouteWithChildren
  AdminADnsIndexRoute: typeof AdminADnsIndexRoute
}

const AdminADnsRouteChildren: AdminADnsRouteChildren = {
  AdminADnsDnsRoute: AdminADnsDnsRouteWithChildren,
  AdminADnsIndexRoute: AdminADnsIndexRoute,
}

const AdminADnsRouteWithChildren = AdminADnsRoute._addFileChildren(
  AdminADnsRouteChildren,
)

interface AdminAExitnodesExitnodesRouteChildren {
  AdminAExitnodesExitnodesApprovedRoute: typeof AdminAExitnodesExitnodesApprovedRoute
  AdminAExitnodesExitnodesPendingRoute: typeof AdminAExitnodesExitnodesPendingRoute
}

const AdminAExitnodesExitnodesRouteChildren: AdminAExitnodesExitnodesRouteChildren =
  {
    AdminAExitnodesExitnodesApprovedRoute:
      AdminAExitnodesExitnodesApprovedRoute,
    AdminAExitnodesExitnodesPendingRoute: AdminAExitnodesExitnodesPendingRoute,
  }

const AdminAExitnodesExitnodesRouteWithChildren =
  AdminAExitnodesExitnodesRoute._addFileChildren(
    AdminAExitnodesExitnodesRouteChildren,
  )

interface AdminAExitnodesRouteChildren {
  AdminAExitnodesExitnodesRoute: typeof AdminAExitnodesExitnodesRouteWithChildren
  AdminAExitnodesIndexRoute: typeof AdminAExitnodesIndexRoute
}

const AdminAExitnodesRouteChildren: AdminAExitnodesRouteChildren = {
  AdminAExitnodesExitnodesRoute: AdminAExitnodesExitnodesRouteWithChildren,
  AdminAExitnodesIndexRoute: AdminAExitnodesIndexRoute,
}

const AdminAExitnodesRouteWithChildren = AdminAExitnodesRoute._addFileChildren(
  AdminAExitnodesRouteChildren,
)

interface AdminAGroupsGroupsRouteChildren {
  AdminAGroupsGroupsLdapRoute: typeof AdminAGroupsGroupsLdapRoute
  AdminAGroupsGroupsLocalRoute: typeof AdminAGroupsGroupsLocalRoute
  AdminAGroupsGroupsScimRoute: typeof AdminAGroupsGroupsScimRoute
}

const AdminAGroupsGroupsRouteChildren: AdminAGroupsGroupsRouteChildren = {
  AdminAGroupsGroupsLdapRoute: AdminAGroupsGroupsLdapRoute,
  AdminAGroupsGroupsLocalRoute: AdminAGroupsGroupsLocalRoute,
  AdminAGroupsGroupsScimRoute: AdminAGroupsGroupsScimRoute,
}

const AdminAGroupsGroupsRouteWithChildren =
  AdminAGroupsGroupsRoute._addFileChildren(AdminAGroupsGroupsRouteChildren)

interface AdminAGroupsGroupIdGroupRouteChildren {
  AdminAGroupsGroupIdGroupGeneralRoute: typeof AdminAGroupsGroupIdGroupGeneralRoute
  AdminAGroupsGroupIdGroupInboundAclsRoute: typeof AdminAGroupsGroupIdGroupInboundAclsRoute
  AdminAGroupsGroupIdGroupOutboundAclsRoute: typeof AdminAGroupsGroupIdGroupOutboundAclsRoute
}

const AdminAGroupsGroupIdGroupRouteChildren: AdminAGroupsGroupIdGroupRouteChildren =
  {
    AdminAGroupsGroupIdGroupGeneralRoute: AdminAGroupsGroupIdGroupGeneralRoute,
    AdminAGroupsGroupIdGroupInboundAclsRoute:
      AdminAGroupsGroupIdGroupInboundAclsRoute,
    AdminAGroupsGroupIdGroupOutboundAclsRoute:
      AdminAGroupsGroupIdGroupOutboundAclsRoute,
  }

const AdminAGroupsGroupIdGroupRouteWithChildren =
  AdminAGroupsGroupIdGroupRoute._addFileChildren(
    AdminAGroupsGroupIdGroupRouteChildren,
  )

interface AdminAGroupsGroupIdRouteChildren {
  AdminAGroupsGroupIdGroupRoute: typeof AdminAGroupsGroupIdGroupRouteWithChildren
}

const AdminAGroupsGroupIdRouteChildren: AdminAGroupsGroupIdRouteChildren = {
  AdminAGroupsGroupIdGroupRoute: AdminAGroupsGroupIdGroupRouteWithChildren,
}

const AdminAGroupsGroupIdRouteWithChildren =
  AdminAGroupsGroupIdRoute._addFileChildren(AdminAGroupsGroupIdRouteChildren)

interface AdminAGroupsRouteChildren {
  AdminAGroupsGroupsRoute: typeof AdminAGroupsGroupsRouteWithChildren
  AdminAGroupsIndexRoute: typeof AdminAGroupsIndexRoute
  AdminAGroupsGroupIdRoute: typeof AdminAGroupsGroupIdRouteWithChildren
}

const AdminAGroupsRouteChildren: AdminAGroupsRouteChildren = {
  AdminAGroupsGroupsRoute: AdminAGroupsGroupsRouteWithChildren,
  AdminAGroupsIndexRoute: AdminAGroupsIndexRoute,
  AdminAGroupsGroupIdRoute: AdminAGroupsGroupIdRouteWithChildren,
}

const AdminAGroupsRouteWithChildren = AdminAGroupsRoute._addFileChildren(
  AdminAGroupsRouteChildren,
)

interface AdminASettingsSettingsRouteChildren {
  AdminASettingsSettingsGeneralRoute: typeof AdminASettingsSettingsGeneralRoute
  AdminASettingsSettingsLdapRoute: typeof AdminASettingsSettingsLdapRoute
  AdminASettingsSettingsScimRoute: typeof AdminASettingsSettingsScimRoute
  AdminASettingsSettingsOidcTrufflepigRoute: typeof AdminASettingsSettingsOidcTrufflepigRoute
  AdminASettingsSettingsOidcIndexRoute: typeof AdminASettingsSettingsOidcIndexRoute
  AdminASettingsSettingsOidcCustomerAdminRoute: typeof AdminASettingsSettingsOidcCustomerAdminRoute
  AdminASettingsSettingsOidcCustomerVpnRoute: typeof AdminASettingsSettingsOidcCustomerVpnRoute
}

const AdminASettingsSettingsRouteChildren: AdminASettingsSettingsRouteChildren =
  {
    AdminASettingsSettingsGeneralRoute: AdminASettingsSettingsGeneralRoute,
    AdminASettingsSettingsLdapRoute: AdminASettingsSettingsLdapRoute,
    AdminASettingsSettingsScimRoute: AdminASettingsSettingsScimRoute,
    AdminASettingsSettingsOidcTrufflepigRoute:
      AdminASettingsSettingsOidcTrufflepigRoute,
    AdminASettingsSettingsOidcIndexRoute: AdminASettingsSettingsOidcIndexRoute,
    AdminASettingsSettingsOidcCustomerAdminRoute:
      AdminASettingsSettingsOidcCustomerAdminRoute,
    AdminASettingsSettingsOidcCustomerVpnRoute:
      AdminASettingsSettingsOidcCustomerVpnRoute,
  }

const AdminASettingsSettingsRouteWithChildren =
  AdminASettingsSettingsRoute._addFileChildren(
    AdminASettingsSettingsRouteChildren,
  )

interface AdminASettingsRouteChildren {
  AdminASettingsSettingsRoute: typeof AdminASettingsSettingsRouteWithChildren
  AdminASettingsIndexRoute: typeof AdminASettingsIndexRoute
}

const AdminASettingsRouteChildren: AdminASettingsRouteChildren = {
  AdminASettingsSettingsRoute: AdminASettingsSettingsRouteWithChildren,
  AdminASettingsIndexRoute: AdminASettingsIndexRoute,
}

const AdminASettingsRouteWithChildren = AdminASettingsRoute._addFileChildren(
  AdminASettingsRouteChildren,
)

interface AdminASubnetsSubnetsRouteChildren {
  AdminASubnetsSubnetsApprovedRoute: typeof AdminASubnetsSubnetsApprovedRoute
  AdminASubnetsSubnetsPendingRoute: typeof AdminASubnetsSubnetsPendingRoute
}

const AdminASubnetsSubnetsRouteChildren: AdminASubnetsSubnetsRouteChildren = {
  AdminASubnetsSubnetsApprovedRoute: AdminASubnetsSubnetsApprovedRoute,
  AdminASubnetsSubnetsPendingRoute: AdminASubnetsSubnetsPendingRoute,
}

const AdminASubnetsSubnetsRouteWithChildren =
  AdminASubnetsSubnetsRoute._addFileChildren(AdminASubnetsSubnetsRouteChildren)

interface AdminASubnetsSubnetIdSubnetRouteChildren {
  AdminASubnetsSubnetIdSubnetInboundAclsRoute: typeof AdminASubnetsSubnetIdSubnetInboundAclsRoute
  AdminASubnetsSubnetIdSubnetOutboundAclsRoute: typeof AdminASubnetsSubnetIdSubnetOutboundAclsRoute
}

const AdminASubnetsSubnetIdSubnetRouteChildren: AdminASubnetsSubnetIdSubnetRouteChildren =
  {
    AdminASubnetsSubnetIdSubnetInboundAclsRoute:
      AdminASubnetsSubnetIdSubnetInboundAclsRoute,
    AdminASubnetsSubnetIdSubnetOutboundAclsRoute:
      AdminASubnetsSubnetIdSubnetOutboundAclsRoute,
  }

const AdminASubnetsSubnetIdSubnetRouteWithChildren =
  AdminASubnetsSubnetIdSubnetRoute._addFileChildren(
    AdminASubnetsSubnetIdSubnetRouteChildren,
  )

interface AdminASubnetsSubnetIdRouteChildren {
  AdminASubnetsSubnetIdSubnetRoute: typeof AdminASubnetsSubnetIdSubnetRouteWithChildren
}

const AdminASubnetsSubnetIdRouteChildren: AdminASubnetsSubnetIdRouteChildren = {
  AdminASubnetsSubnetIdSubnetRoute:
    AdminASubnetsSubnetIdSubnetRouteWithChildren,
}

const AdminASubnetsSubnetIdRouteWithChildren =
  AdminASubnetsSubnetIdRoute._addFileChildren(
    AdminASubnetsSubnetIdRouteChildren,
  )

interface AdminASubnetsRouteChildren {
  AdminASubnetsSubnetsRoute: typeof AdminASubnetsSubnetsRouteWithChildren
  AdminASubnetsIndexRoute: typeof AdminASubnetsIndexRoute
  AdminASubnetsSubnetIdRoute: typeof AdminASubnetsSubnetIdRouteWithChildren
}

const AdminASubnetsRouteChildren: AdminASubnetsRouteChildren = {
  AdminASubnetsSubnetsRoute: AdminASubnetsSubnetsRouteWithChildren,
  AdminASubnetsIndexRoute: AdminASubnetsIndexRoute,
  AdminASubnetsSubnetIdRoute: AdminASubnetsSubnetIdRouteWithChildren,
}

const AdminASubnetsRouteWithChildren = AdminASubnetsRoute._addFileChildren(
  AdminASubnetsRouteChildren,
)

interface AdminADevicesDeviceIdDeviceRouteChildren {
  AdminADevicesDeviceIdDeviceGeneralRoute: typeof AdminADevicesDeviceIdDeviceGeneralRoute
  AdminADevicesDeviceIdDeviceInboundAclsRoute: typeof AdminADevicesDeviceIdDeviceInboundAclsRoute
  AdminADevicesDeviceIdDeviceOutboundAclsRoute: typeof AdminADevicesDeviceIdDeviceOutboundAclsRoute
}

const AdminADevicesDeviceIdDeviceRouteChildren: AdminADevicesDeviceIdDeviceRouteChildren =
  {
    AdminADevicesDeviceIdDeviceGeneralRoute:
      AdminADevicesDeviceIdDeviceGeneralRoute,
    AdminADevicesDeviceIdDeviceInboundAclsRoute:
      AdminADevicesDeviceIdDeviceInboundAclsRoute,
    AdminADevicesDeviceIdDeviceOutboundAclsRoute:
      AdminADevicesDeviceIdDeviceOutboundAclsRoute,
  }

const AdminADevicesDeviceIdDeviceRouteWithChildren =
  AdminADevicesDeviceIdDeviceRoute._addFileChildren(
    AdminADevicesDeviceIdDeviceRouteChildren,
  )

interface AdminADevicesDeviceIdRouteChildren {
  AdminADevicesDeviceIdDeviceRoute: typeof AdminADevicesDeviceIdDeviceRouteWithChildren
}

const AdminADevicesDeviceIdRouteChildren: AdminADevicesDeviceIdRouteChildren = {
  AdminADevicesDeviceIdDeviceRoute:
    AdminADevicesDeviceIdDeviceRouteWithChildren,
}

const AdminADevicesDeviceIdRouteWithChildren =
  AdminADevicesDeviceIdRoute._addFileChildren(
    AdminADevicesDeviceIdRouteChildren,
  )

interface AdminATagsTagIdTagsRouteChildren {
  AdminATagsTagIdTagsAssociatedRoute: typeof AdminATagsTagIdTagsAssociatedRoute
  AdminATagsTagIdTagsInboundAclsRoute: typeof AdminATagsTagIdTagsInboundAclsRoute
  AdminATagsTagIdTagsOutboundAclsRoute: typeof AdminATagsTagIdTagsOutboundAclsRoute
}

const AdminATagsTagIdTagsRouteChildren: AdminATagsTagIdTagsRouteChildren = {
  AdminATagsTagIdTagsAssociatedRoute: AdminATagsTagIdTagsAssociatedRoute,
  AdminATagsTagIdTagsInboundAclsRoute: AdminATagsTagIdTagsInboundAclsRoute,
  AdminATagsTagIdTagsOutboundAclsRoute: AdminATagsTagIdTagsOutboundAclsRoute,
}

const AdminATagsTagIdTagsRouteWithChildren =
  AdminATagsTagIdTagsRoute._addFileChildren(AdminATagsTagIdTagsRouteChildren)

interface AdminATagsTagIdRouteChildren {
  AdminATagsTagIdTagsRoute: typeof AdminATagsTagIdTagsRouteWithChildren
}

const AdminATagsTagIdRouteChildren: AdminATagsTagIdRouteChildren = {
  AdminATagsTagIdTagsRoute: AdminATagsTagIdTagsRouteWithChildren,
}

const AdminATagsTagIdRouteWithChildren = AdminATagsTagIdRoute._addFileChildren(
  AdminATagsTagIdRouteChildren,
)

interface AdminAUsersUserIdUserRouteChildren {
  AdminAUsersUserIdUserGeneralRoute: typeof AdminAUsersUserIdUserGeneralRoute
}

const AdminAUsersUserIdUserRouteChildren: AdminAUsersUserIdUserRouteChildren = {
  AdminAUsersUserIdUserGeneralRoute: AdminAUsersUserIdUserGeneralRoute,
}

const AdminAUsersUserIdUserRouteWithChildren =
  AdminAUsersUserIdUserRoute._addFileChildren(
    AdminAUsersUserIdUserRouteChildren,
  )

interface AdminAUsersUserIdRouteChildren {
  AdminAUsersUserIdUserRoute: typeof AdminAUsersUserIdUserRouteWithChildren
}

const AdminAUsersUserIdRouteChildren: AdminAUsersUserIdRouteChildren = {
  AdminAUsersUserIdUserRoute: AdminAUsersUserIdUserRouteWithChildren,
}

const AdminAUsersUserIdRouteWithChildren =
  AdminAUsersUserIdRoute._addFileChildren(AdminAUsersUserIdRouteChildren)

interface AdminLazyRouteChildren {
  AdminADevicesCreateServerRoute: typeof AdminADevicesCreateServerRoute
  AdminADnsRoute: typeof AdminADnsRouteWithChildren
  AdminAExitnodesRoute: typeof AdminAExitnodesRouteWithChildren
  AdminAGroupsRoute: typeof AdminAGroupsRouteWithChildren
  AdminASettingsRoute: typeof AdminASettingsRouteWithChildren
  AdminASubnetsRoute: typeof AdminASubnetsRouteWithChildren
  AdminAAccountsIndexRoute: typeof AdminAAccountsIndexRoute
  AdminADashboardIndexRoute: typeof AdminADashboardIndexRoute
  AdminADevicesIndexRoute: typeof AdminADevicesIndexRoute
  AdminALogsIndexRoute: typeof AdminALogsIndexRoute
  AdminAPreauthkeysIndexRoute: typeof AdminAPreauthkeysIndexRoute
  AdminAProfileIndexRoute: typeof AdminAProfileIndexRoute
  AdminATagsIndexRoute: typeof AdminATagsIndexRoute
  AdminAUsersIndexRoute: typeof AdminAUsersIndexRoute
  AdminADevicesDeviceIdRoute: typeof AdminADevicesDeviceIdRouteWithChildren
  AdminATagsTagIdRoute: typeof AdminATagsTagIdRouteWithChildren
  AdminAUsersUserIdRoute: typeof AdminAUsersUserIdRouteWithChildren
}

const AdminLazyRouteChildren: AdminLazyRouteChildren = {
  AdminADevicesCreateServerRoute: AdminADevicesCreateServerRoute,
  AdminADnsRoute: AdminADnsRouteWithChildren,
  AdminAExitnodesRoute: AdminAExitnodesRouteWithChildren,
  AdminAGroupsRoute: AdminAGroupsRouteWithChildren,
  AdminASettingsRoute: AdminASettingsRouteWithChildren,
  AdminASubnetsRoute: AdminASubnetsRouteWithChildren,
  AdminAAccountsIndexRoute: AdminAAccountsIndexRoute,
  AdminADashboardIndexRoute: AdminADashboardIndexRoute,
  AdminADevicesIndexRoute: AdminADevicesIndexRoute,
  AdminALogsIndexRoute: AdminALogsIndexRoute,
  AdminAPreauthkeysIndexRoute: AdminAPreauthkeysIndexRoute,
  AdminAProfileIndexRoute: AdminAProfileIndexRoute,
  AdminATagsIndexRoute: AdminATagsIndexRoute,
  AdminAUsersIndexRoute: AdminAUsersIndexRoute,
  AdminADevicesDeviceIdRoute: AdminADevicesDeviceIdRouteWithChildren,
  AdminATagsTagIdRoute: AdminATagsTagIdRouteWithChildren,
  AdminAUsersUserIdRoute: AdminAUsersUserIdRouteWithChildren,
}

const AdminLazyRouteWithChildren = AdminLazyRoute._addFileChildren(
  AdminLazyRouteChildren,
)

interface CustomerCExitnodesExitnodesRouteChildren {
  CustomerCExitnodesExitnodesApprovedRoute: typeof CustomerCExitnodesExitnodesApprovedRoute
  CustomerCExitnodesExitnodesPendingRoute: typeof CustomerCExitnodesExitnodesPendingRoute
}

const CustomerCExitnodesExitnodesRouteChildren: CustomerCExitnodesExitnodesRouteChildren =
  {
    CustomerCExitnodesExitnodesApprovedRoute:
      CustomerCExitnodesExitnodesApprovedRoute,
    CustomerCExitnodesExitnodesPendingRoute:
      CustomerCExitnodesExitnodesPendingRoute,
  }

const CustomerCExitnodesExitnodesRouteWithChildren =
  CustomerCExitnodesExitnodesRoute._addFileChildren(
    CustomerCExitnodesExitnodesRouteChildren,
  )

interface CustomerCExitnodesRouteChildren {
  CustomerCExitnodesExitnodesRoute: typeof CustomerCExitnodesExitnodesRouteWithChildren
  CustomerCExitnodesIndexRoute: typeof CustomerCExitnodesIndexRoute
}

const CustomerCExitnodesRouteChildren: CustomerCExitnodesRouteChildren = {
  CustomerCExitnodesExitnodesRoute:
    CustomerCExitnodesExitnodesRouteWithChildren,
  CustomerCExitnodesIndexRoute: CustomerCExitnodesIndexRoute,
}

const CustomerCExitnodesRouteWithChildren =
  CustomerCExitnodesRoute._addFileChildren(CustomerCExitnodesRouteChildren)

interface CustomerCGroupsGroupsRouteChildren {
  CustomerCGroupsGroupsLdapRoute: typeof CustomerCGroupsGroupsLdapRoute
  CustomerCGroupsGroupsLocalRoute: typeof CustomerCGroupsGroupsLocalRoute
  CustomerCGroupsGroupsScimRoute: typeof CustomerCGroupsGroupsScimRoute
}

const CustomerCGroupsGroupsRouteChildren: CustomerCGroupsGroupsRouteChildren = {
  CustomerCGroupsGroupsLdapRoute: CustomerCGroupsGroupsLdapRoute,
  CustomerCGroupsGroupsLocalRoute: CustomerCGroupsGroupsLocalRoute,
  CustomerCGroupsGroupsScimRoute: CustomerCGroupsGroupsScimRoute,
}

const CustomerCGroupsGroupsRouteWithChildren =
  CustomerCGroupsGroupsRoute._addFileChildren(
    CustomerCGroupsGroupsRouteChildren,
  )

interface CustomerCGroupsGroupIdGroupRouteChildren {
  CustomerCGroupsGroupIdGroupGeneralRoute: typeof CustomerCGroupsGroupIdGroupGeneralRoute
  CustomerCGroupsGroupIdGroupInboundAclsRoute: typeof CustomerCGroupsGroupIdGroupInboundAclsRoute
  CustomerCGroupsGroupIdGroupOutboundAclsRoute: typeof CustomerCGroupsGroupIdGroupOutboundAclsRoute
}

const CustomerCGroupsGroupIdGroupRouteChildren: CustomerCGroupsGroupIdGroupRouteChildren =
  {
    CustomerCGroupsGroupIdGroupGeneralRoute:
      CustomerCGroupsGroupIdGroupGeneralRoute,
    CustomerCGroupsGroupIdGroupInboundAclsRoute:
      CustomerCGroupsGroupIdGroupInboundAclsRoute,
    CustomerCGroupsGroupIdGroupOutboundAclsRoute:
      CustomerCGroupsGroupIdGroupOutboundAclsRoute,
  }

const CustomerCGroupsGroupIdGroupRouteWithChildren =
  CustomerCGroupsGroupIdGroupRoute._addFileChildren(
    CustomerCGroupsGroupIdGroupRouteChildren,
  )

interface CustomerCGroupsGroupIdRouteChildren {
  CustomerCGroupsGroupIdGroupRoute: typeof CustomerCGroupsGroupIdGroupRouteWithChildren
}

const CustomerCGroupsGroupIdRouteChildren: CustomerCGroupsGroupIdRouteChildren =
  {
    CustomerCGroupsGroupIdGroupRoute:
      CustomerCGroupsGroupIdGroupRouteWithChildren,
  }

const CustomerCGroupsGroupIdRouteWithChildren =
  CustomerCGroupsGroupIdRoute._addFileChildren(
    CustomerCGroupsGroupIdRouteChildren,
  )

interface CustomerCGroupsRouteChildren {
  CustomerCGroupsGroupsRoute: typeof CustomerCGroupsGroupsRouteWithChildren
  CustomerCGroupsIndexRoute: typeof CustomerCGroupsIndexRoute
  CustomerCGroupsGroupIdRoute: typeof CustomerCGroupsGroupIdRouteWithChildren
}

const CustomerCGroupsRouteChildren: CustomerCGroupsRouteChildren = {
  CustomerCGroupsGroupsRoute: CustomerCGroupsGroupsRouteWithChildren,
  CustomerCGroupsIndexRoute: CustomerCGroupsIndexRoute,
  CustomerCGroupsGroupIdRoute: CustomerCGroupsGroupIdRouteWithChildren,
}

const CustomerCGroupsRouteWithChildren = CustomerCGroupsRoute._addFileChildren(
  CustomerCGroupsRouteChildren,
)

interface CustomerCSubnetsSubnetsRouteChildren {
  CustomerCSubnetsSubnetsApprovedRoute: typeof CustomerCSubnetsSubnetsApprovedRoute
  CustomerCSubnetsSubnetsPendingRoute: typeof CustomerCSubnetsSubnetsPendingRoute
}

const CustomerCSubnetsSubnetsRouteChildren: CustomerCSubnetsSubnetsRouteChildren =
  {
    CustomerCSubnetsSubnetsApprovedRoute: CustomerCSubnetsSubnetsApprovedRoute,
    CustomerCSubnetsSubnetsPendingRoute: CustomerCSubnetsSubnetsPendingRoute,
  }

const CustomerCSubnetsSubnetsRouteWithChildren =
  CustomerCSubnetsSubnetsRoute._addFileChildren(
    CustomerCSubnetsSubnetsRouteChildren,
  )

interface CustomerCSubnetsSubnetIdSubnetRouteChildren {
  CustomerCSubnetsSubnetIdSubnetInboundAclsRoute: typeof CustomerCSubnetsSubnetIdSubnetInboundAclsRoute
  CustomerCSubnetsSubnetIdSubnetOutboundAclsRoute: typeof CustomerCSubnetsSubnetIdSubnetOutboundAclsRoute
}

const CustomerCSubnetsSubnetIdSubnetRouteChildren: CustomerCSubnetsSubnetIdSubnetRouteChildren =
  {
    CustomerCSubnetsSubnetIdSubnetInboundAclsRoute:
      CustomerCSubnetsSubnetIdSubnetInboundAclsRoute,
    CustomerCSubnetsSubnetIdSubnetOutboundAclsRoute:
      CustomerCSubnetsSubnetIdSubnetOutboundAclsRoute,
  }

const CustomerCSubnetsSubnetIdSubnetRouteWithChildren =
  CustomerCSubnetsSubnetIdSubnetRoute._addFileChildren(
    CustomerCSubnetsSubnetIdSubnetRouteChildren,
  )

interface CustomerCSubnetsSubnetIdRouteChildren {
  CustomerCSubnetsSubnetIdSubnetRoute: typeof CustomerCSubnetsSubnetIdSubnetRouteWithChildren
}

const CustomerCSubnetsSubnetIdRouteChildren: CustomerCSubnetsSubnetIdRouteChildren =
  {
    CustomerCSubnetsSubnetIdSubnetRoute:
      CustomerCSubnetsSubnetIdSubnetRouteWithChildren,
  }

const CustomerCSubnetsSubnetIdRouteWithChildren =
  CustomerCSubnetsSubnetIdRoute._addFileChildren(
    CustomerCSubnetsSubnetIdRouteChildren,
  )

interface CustomerCSubnetsRouteChildren {
  CustomerCSubnetsSubnetsRoute: typeof CustomerCSubnetsSubnetsRouteWithChildren
  CustomerCSubnetsIndexRoute: typeof CustomerCSubnetsIndexRoute
  CustomerCSubnetsSubnetIdRoute: typeof CustomerCSubnetsSubnetIdRouteWithChildren
}

const CustomerCSubnetsRouteChildren: CustomerCSubnetsRouteChildren = {
  CustomerCSubnetsSubnetsRoute: CustomerCSubnetsSubnetsRouteWithChildren,
  CustomerCSubnetsIndexRoute: CustomerCSubnetsIndexRoute,
  CustomerCSubnetsSubnetIdRoute: CustomerCSubnetsSubnetIdRouteWithChildren,
}

const CustomerCSubnetsRouteWithChildren =
  CustomerCSubnetsRoute._addFileChildren(CustomerCSubnetsRouteChildren)

interface CustomerCDevicesDeviceIdDeviceRouteChildren {
  CustomerCDevicesDeviceIdDeviceGeneralRoute: typeof CustomerCDevicesDeviceIdDeviceGeneralRoute
  CustomerCDevicesDeviceIdDeviceInboundAclsRoute: typeof CustomerCDevicesDeviceIdDeviceInboundAclsRoute
  CustomerCDevicesDeviceIdDeviceOutboundAclsRoute: typeof CustomerCDevicesDeviceIdDeviceOutboundAclsRoute
}

const CustomerCDevicesDeviceIdDeviceRouteChildren: CustomerCDevicesDeviceIdDeviceRouteChildren =
  {
    CustomerCDevicesDeviceIdDeviceGeneralRoute:
      CustomerCDevicesDeviceIdDeviceGeneralRoute,
    CustomerCDevicesDeviceIdDeviceInboundAclsRoute:
      CustomerCDevicesDeviceIdDeviceInboundAclsRoute,
    CustomerCDevicesDeviceIdDeviceOutboundAclsRoute:
      CustomerCDevicesDeviceIdDeviceOutboundAclsRoute,
  }

const CustomerCDevicesDeviceIdDeviceRouteWithChildren =
  CustomerCDevicesDeviceIdDeviceRoute._addFileChildren(
    CustomerCDevicesDeviceIdDeviceRouteChildren,
  )

interface CustomerCDevicesDeviceIdRouteChildren {
  CustomerCDevicesDeviceIdDeviceRoute: typeof CustomerCDevicesDeviceIdDeviceRouteWithChildren
}

const CustomerCDevicesDeviceIdRouteChildren: CustomerCDevicesDeviceIdRouteChildren =
  {
    CustomerCDevicesDeviceIdDeviceRoute:
      CustomerCDevicesDeviceIdDeviceRouteWithChildren,
  }

const CustomerCDevicesDeviceIdRouteWithChildren =
  CustomerCDevicesDeviceIdRoute._addFileChildren(
    CustomerCDevicesDeviceIdRouteChildren,
  )

interface CustomerCTagsTagIdTagsRouteChildren {
  CustomerCTagsTagIdTagsAssociatedRoute: typeof CustomerCTagsTagIdTagsAssociatedRoute
  CustomerCTagsTagIdTagsInboundAclsRoute: typeof CustomerCTagsTagIdTagsInboundAclsRoute
  CustomerCTagsTagIdTagsOutboundAclsRoute: typeof CustomerCTagsTagIdTagsOutboundAclsRoute
}

const CustomerCTagsTagIdTagsRouteChildren: CustomerCTagsTagIdTagsRouteChildren =
  {
    CustomerCTagsTagIdTagsAssociatedRoute:
      CustomerCTagsTagIdTagsAssociatedRoute,
    CustomerCTagsTagIdTagsInboundAclsRoute:
      CustomerCTagsTagIdTagsInboundAclsRoute,
    CustomerCTagsTagIdTagsOutboundAclsRoute:
      CustomerCTagsTagIdTagsOutboundAclsRoute,
  }

const CustomerCTagsTagIdTagsRouteWithChildren =
  CustomerCTagsTagIdTagsRoute._addFileChildren(
    CustomerCTagsTagIdTagsRouteChildren,
  )

interface CustomerCTagsTagIdRouteChildren {
  CustomerCTagsTagIdTagsRoute: typeof CustomerCTagsTagIdTagsRouteWithChildren
}

const CustomerCTagsTagIdRouteChildren: CustomerCTagsTagIdRouteChildren = {
  CustomerCTagsTagIdTagsRoute: CustomerCTagsTagIdTagsRouteWithChildren,
}

const CustomerCTagsTagIdRouteWithChildren =
  CustomerCTagsTagIdRoute._addFileChildren(CustomerCTagsTagIdRouteChildren)

interface CustomerCUsersUserIdUserRouteChildren {
  CustomerCUsersUserIdUserGeneralRoute: typeof CustomerCUsersUserIdUserGeneralRoute
}

const CustomerCUsersUserIdUserRouteChildren: CustomerCUsersUserIdUserRouteChildren =
  {
    CustomerCUsersUserIdUserGeneralRoute: CustomerCUsersUserIdUserGeneralRoute,
  }

const CustomerCUsersUserIdUserRouteWithChildren =
  CustomerCUsersUserIdUserRoute._addFileChildren(
    CustomerCUsersUserIdUserRouteChildren,
  )

interface CustomerCUsersUserIdRouteChildren {
  CustomerCUsersUserIdUserRoute: typeof CustomerCUsersUserIdUserRouteWithChildren
}

const CustomerCUsersUserIdRouteChildren: CustomerCUsersUserIdRouteChildren = {
  CustomerCUsersUserIdUserRoute: CustomerCUsersUserIdUserRouteWithChildren,
}

const CustomerCUsersUserIdRouteWithChildren =
  CustomerCUsersUserIdRoute._addFileChildren(CustomerCUsersUserIdRouteChildren)

interface CustomerLazyRouteChildren {
  CustomerCExitnodesRoute: typeof CustomerCExitnodesRouteWithChildren
  CustomerCGroupsRoute: typeof CustomerCGroupsRouteWithChildren
  CustomerCSubnetsRoute: typeof CustomerCSubnetsRouteWithChildren
  CustomerCDashboardIndexRoute: typeof CustomerCDashboardIndexRoute
  CustomerCDevicesIndexRoute: typeof CustomerCDevicesIndexRoute
  CustomerCLogsIndexRoute: typeof CustomerCLogsIndexRoute
  CustomerCProfileIndexRoute: typeof CustomerCProfileIndexRoute
  CustomerCTagsIndexRoute: typeof CustomerCTagsIndexRoute
  CustomerCUsersIndexRoute: typeof CustomerCUsersIndexRoute
  CustomerCDevicesDeviceIdRoute: typeof CustomerCDevicesDeviceIdRouteWithChildren
  CustomerCTagsTagIdRoute: typeof CustomerCTagsTagIdRouteWithChildren
  CustomerCUsersUserIdRoute: typeof CustomerCUsersUserIdRouteWithChildren
}

const CustomerLazyRouteChildren: CustomerLazyRouteChildren = {
  CustomerCExitnodesRoute: CustomerCExitnodesRouteWithChildren,
  CustomerCGroupsRoute: CustomerCGroupsRouteWithChildren,
  CustomerCSubnetsRoute: CustomerCSubnetsRouteWithChildren,
  CustomerCDashboardIndexRoute: CustomerCDashboardIndexRoute,
  CustomerCDevicesIndexRoute: CustomerCDevicesIndexRoute,
  CustomerCLogsIndexRoute: CustomerCLogsIndexRoute,
  CustomerCProfileIndexRoute: CustomerCProfileIndexRoute,
  CustomerCTagsIndexRoute: CustomerCTagsIndexRoute,
  CustomerCUsersIndexRoute: CustomerCUsersIndexRoute,
  CustomerCDevicesDeviceIdRoute: CustomerCDevicesDeviceIdRouteWithChildren,
  CustomerCTagsTagIdRoute: CustomerCTagsTagIdRouteWithChildren,
  CustomerCUsersUserIdRoute: CustomerCUsersUserIdRouteWithChildren,
}

const CustomerLazyRouteWithChildren = CustomerLazyRoute._addFileChildren(
  CustomerLazyRouteChildren,
)

interface StaticLazyRouteChildren {
  StaticSTailscaleLoginDisabledRoute: typeof StaticSTailscaleLoginDisabledRoute
  StaticSTailscaleLoginInvalidCsrfRoute: typeof StaticSTailscaleLoginInvalidCsrfRoute
  StaticSTailscaleLoginOutdatedRoute: typeof StaticSTailscaleLoginOutdatedRoute
  StaticSTailscaleLoginServerErrorRoute: typeof StaticSTailscaleLoginServerErrorRoute
  StaticSTailscaleLoginSuccessRoute: typeof StaticSTailscaleLoginSuccessRoute
  StaticSTailscaleLoginTokenExternalTailscaleLoginRoute: typeof StaticSTailscaleLoginTokenExternalTailscaleLoginRoute
  StaticSTailscaleLoginTokenIndexRoute: typeof StaticSTailscaleLoginTokenIndexRoute
}

const StaticLazyRouteChildren: StaticLazyRouteChildren = {
  StaticSTailscaleLoginDisabledRoute: StaticSTailscaleLoginDisabledRoute,
  StaticSTailscaleLoginInvalidCsrfRoute: StaticSTailscaleLoginInvalidCsrfRoute,
  StaticSTailscaleLoginOutdatedRoute: StaticSTailscaleLoginOutdatedRoute,
  StaticSTailscaleLoginServerErrorRoute: StaticSTailscaleLoginServerErrorRoute,
  StaticSTailscaleLoginSuccessRoute: StaticSTailscaleLoginSuccessRoute,
  StaticSTailscaleLoginTokenExternalTailscaleLoginRoute:
    StaticSTailscaleLoginTokenExternalTailscaleLoginRoute,
  StaticSTailscaleLoginTokenIndexRoute: StaticSTailscaleLoginTokenIndexRoute,
}

const StaticLazyRouteWithChildren = StaticLazyRoute._addFileChildren(
  StaticLazyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminLazyRoute: AdminLazyRouteWithChildren,
  CustomerLazyRoute: CustomerLazyRouteWithChildren,
  StaticLazyRoute: StaticLazyRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
